window.__SLB_DIARY_BUILD_TAG__="SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01";
/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.diary.js
Source: slb_src/slices/diary/
Build: slb_build/build_diary.mjs
Built: 2026-09-19T16:53:57.372Z
Content-SHA256: 981bb81fe9dc03669ec6c1a710ec4df1586e4498754d908289e3361f5e85a174
Content-SHA256-12: 981bb81fe9dc
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.diary.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

/* SLB Diary (Option B style: single live rich editor, like Library) */
(function(){
  "use strict";

  if(window.__SLB_DIARY_BOOT__) return;
  window.__SLB_DIARY_BOOT__ = true;

  function $(id){ return document.getElementById(id); }
  function esc(s){
    return String(s==null?"":s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  

  // --- Helpers: BBCode ↔ HTML and plain preview ---
  function looksLikeBbcode(s){
    s = String(s||"");
    return /\[(b|i|u|s|color|size|url|img|quote|code)(?:=[^\]]+)?\]/i.test(s);
  }
  function bbcodeToHtml(bb){
    bb = String(bb==null?"":bb);
    // escape HTML first
    let s = esc(bb);
    // normalize newlines
    s = s.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
    // simple nested replacements (run a few passes)
    function pass(x){
      x = x.replace(/\[b\]([\s\S]*?)\[\/b\]/gi, "<b>$1</b>");
      x = x.replace(/\[i\]([\s\S]*?)\[\/i\]/gi, "<i>$1</i>");
      x = x.replace(/\[u\]([\s\S]*?)\[\/u\]/gi, "<u>$1</u>");
      x = x.replace(/\[s\]([\s\S]*?)\[\/s\]/gi, "<s>$1</s>");
      x = x.replace(/\[color=([#a-zA-Z0-9]+)\]([\s\S]*?)\[\/color\]/gi, function(_,c,t){ return '<span style="color:'+c+';">'+t+'</span>'; });
      x = x.replace(/\[size=([0-9]{1,3})\]([\s\S]*?)\[\/size\]/gi, function(_,n,t){ return '<span style="font-size:'+n+'px;">'+t+'</span>'; });
      x = x.replace(/\[url=([^\]]+)\]([\s\S]*?)\[\/url\]/gi, function(_,u,t){ return '<a href="'+esc(u)+'" target="_blank" rel="noopener">'+t+'</a>'; });
      x = x.replace(/\[img\]([\s\S]*?)\[\/img\]/gi, function(_,u){ return '<img src="'+esc(u)+'" alt="" />'; });
      x = x.replace(/\[quote\]([\s\S]*?)\[\/quote\]/gi, "<blockquote>$1</blockquote>");
      return x;
    }
    for(let i=0;i<4;i++){
      const p = pass(s);
      if(p===s) break;
      s = p;
    }
    // newlines → <br>
    s = s.replace(/\n/g, "<br>");
    return s;
  }
  function htmlToPlain(html){
    try{
      const d = document.createElement('div');
      d.innerHTML = String(html||'');
      return String(d.innerText || d.textContent || '').trim();
    }catch(_e){
      return String(html||'').replace(/<[^>]+>/g,' ').replace(/\s+/g,' ').trim();
    }
  }
  function bbcodeToPlain(bb){
    return String(bb||'')
      .replace(/\[[^\]]+\]/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function mergeTags(a, b){
    const seen = new Set();
    const out = [];
    function addAll(s){
      String(s||'')
        .split(/[,，]/)
        .map(x=>String(x||'').trim())
        .filter(Boolean)
        .forEach(t=>{
          const k = t.toLowerCase();
          if(seen.has(k)) return;
          seen.add(k);
          out.push(t);
        });
    }
    addAll(a);
    addAll(b);
    return out.join(', ');
  }

  function toHtmlMaybe(s){
    s = String(s||'');
    if(!s) return '';
    if(looksLikeBbcode(s)) return bbcodeToHtml(s);
    // If no html tags, treat as plain text
    if(!/[<][a-z\/!]/i.test(s)) return esc(s).replace(/\r\n/g,"\n").replace(/\r/g,"\n").replace(/\n/g,"<br>");
    return s;
  }
  function normDateKey(s){
    s = String(s||'').trim();
    const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if(m){
      const y=m[1], mo=('0'+m[2]).slice(-2), d=('0'+m[3]).slice(-2);
      return y+'-'+mo+'-'+d;
    }
    return (/^\d{4}-\d{2}-\d{2}$/.test(s)) ? s : '';
  }
  function fmtTimeToronto(iso){
    iso = String(iso||'').trim();
    if(!iso) return '';
    try{
      const dt = new Date(iso);
      if(!isFinite(dt.getTime())) return '';
      const fmt = new Intl.DateTimeFormat('en-CA', { timeZone:'America/Toronto', hour:'2-digit', minute:'2-digit', hour12:false });
      return fmt.format(dt);
    }catch(_e){ return ''; }
  }

function rpc(action, payload, opts){
    if(window.SLB_APP && typeof SLB_APP.rpc === 'function') return SLB_APP.rpc(action, payload||{}, opts||{});
    if(window.TYW && typeof TYW.rpc === 'function') return TYW.rpc(action, payload||{}, opts||{});
    return Promise.reject(new Error('RPC not available'));
  }

  // Safety: prevent the UI from being stuck forever if an RPC never resolves.
  function isStaleRequest_(err){
    try{ return !!(window.SLB_REQUEST_LIFECYCLE && typeof window.SLB_REQUEST_LIFECYCLE.isStale === 'function' && window.SLB_REQUEST_LIFECYCLE.isStale(err)); }catch(_e){ return false; }
  }
  function invalidateLatest_(key){
    try{ if(window.SLB_REQUEST_LIFECYCLE && typeof window.SLB_REQUEST_LIFECYCLE.invalidate === 'function') window.SLB_REQUEST_LIFECYCLE.invalidate(key); }catch(_e){}
  }

  function rpcWithTimeout(action, payload, opts, timeoutMs){
    timeoutMs = Number(timeoutMs || 0);
    if(!(timeoutMs > 0)) return rpc(action, payload, opts);
    var to = null;
    var p;
    try{ p = rpc(action, payload, opts); }catch(e){ return Promise.reject(e); }
    return Promise.race([
      p,
      new Promise(function(_, reject){
        to = setTimeout(function(){
          reject(new Error('Timeout: ' + String(action||'')));
        }, timeoutMs);
      })
    ]).finally(function(){
      try{ if(to) clearTimeout(to); }catch(_e){}
    });
  }

  function getRole(){
    try{
      const H = window.SLB_SESSION && typeof window.SLB_SESSION.peek==='function' ? window.SLB_SESSION.peek() : null;
      if(H&&H.callsign) return {callsign:H.callsign,isAdmin:!!H.isAdmin,isModerator:!!H.isModerator,isAdminOrMod:!!H.isAdminOrMod};
      const S = window.SLB_APP && SLB_APP.S;
      return {
        callsign: (S && S.callsign) || (sessionStorage.getItem('tyw_callsign')||''),
        isAdmin: !!(S && S.isAdmin),
        isModerator: !!(S && S.isModerator),
        isAdminOrMod: !!(S && (S.isAdminOrMod || S.isAdmin || S.isModerator))
      };
    }catch(_e){
      try{const H=window.SLB_SESSION&&window.SLB_SESSION.peek&&window.SLB_SESSION.peek();if(H)return {callsign:H.callsign||'',isAdmin:!!H.isAdmin,isModerator:!!H.isModerator,isAdminOrMod:!!H.isAdminOrMod};}catch(_e2){}
      return { callsign: sessionStorage.getItem('tyw_callsign')||'', isAdmin:false, isModerator:false, isAdminOrMod:false };
    }
  }


  function obKeyDiary_(payload){
    try{
      payload = payload || {};
      var role = getRole();
      var cs = String(payload.callsign || role.callsign || "");
      var dk = String(payload.dateKey || "");
      if(!dk) return "";
      return cs + "|" + dk;
    }catch(_e){ return ""; }
  }

  function torontoDateKey(d){
    try{
      const fmt = new Intl.DateTimeFormat('en-CA', { timeZone:'America/Toronto', year:'numeric', month:'2-digit', day:'2-digit' });
      return fmt.format(d); // YYYY-MM-DD
    }catch(_e){
      // fallback: local date
      const z = new Date(d);
      const y = z.getFullYear();
      const m = String(z.getMonth()+1).padStart(2,'0');
      const da = String(z.getDate()).padStart(2,'0');
      return `${y}-${m}-${da}`;
    }
  }

  // ===== Rich HTML sanitizer (client-side; server sanitizes too) =====
  const RICH_ALLOWED_TAGS = new Set([
    'B','STRONG','I','EM','U','S','DEL','STRIKE','BR','P','DIV','SPAN',
    'UL','OL','LI','BLOCKQUOTE','H1','H2','H3','H4',
    'A','IMG','IFRAME'
  ]);
  const RICH_ALLOWED_ATTRS = {
    'A': new Set(['href','target','rel','title']),
    'IMG': new Set(['src','alt','title','width','height','loading']),
    'SPAN': new Set(['style']),
    'DIV': new Set(['style','class']),
    'P': new Set(['style']),
    'H1': new Set(['style']),
    'H2': new Set(['style']),
    'H3': new Set(['style']),
    'H4': new Set(['style']),
    'IFRAME': new Set(['src','width','height','title','allow','allowfullscreen','frameborder','loading','referrerpolicy','class'])
  };

  function safeUrl(u){
    u = String(u||'').trim();
    if(!u) return '';
    const low = u.toLowerCase();
    if(low.startsWith('javascript:') || low.startsWith('data:') || low.startsWith('vbscript:')) return '';
    if(low.startsWith('http://') || low.startsWith('https://')) return u;
    return '';
  }

  function sanitizeStyle(style){
    style = String(style||'');
    if(!style) return '';
    const allow = new Set(['color','background-color','font-size','text-decoration','font-weight','font-style','text-align']);
    const out = [];
    style.split(';').forEach(pair => {
      const p = pair.split(':');
      if(p.length < 2) return;
      const k = String(p[0]||'').trim().toLowerCase();
      let v = String(p.slice(1).join(':')||'').trim();
      if(!allow.has(k) || !v) return;
      if(/url\s*\(/i.test(v)) return;
      if(k === 'font-size'){
        const m = v.match(/(\d{1,3})\s*px/i);
        if(!m) return;
        const n = Math.max(8, Math.min(48, parseInt(m[1],10)));
        v = n + 'px';
      }
      out.push(k + ':' + v);
    });
    return out.join(';');
  }

  function sanitizeRichHtml(html){
    html = String(html||'');
    if(!html.trim()) return '';
    let doc;
    try{ doc = new DOMParser().parseFromString('<div id="__wrap">' + html + '</div>', 'text/html'); }
    catch(_e){ return ''; }
    const wrap = doc.getElementById('__wrap');
    if(!wrap) return '';

    const walk = (node) => {
      const kids = Array.from(node.childNodes || []);
      for(const child of kids){
        if(child.nodeType === 1){
          const tag = child.tagName;
          if(!RICH_ALLOWED_TAGS.has(tag)){
            const frag = doc.createDocumentFragment();
            while(child.firstChild) frag.appendChild(child.firstChild);
            child.replaceWith(frag);
            continue;
          }
          const allowA = RICH_ALLOWED_ATTRS[tag] || new Set();
          Array.from(child.attributes || []).forEach(a => {
            const name = String(a.name||'').toLowerCase();
            if(name.startsWith('on')){ child.removeAttribute(a.name); return; }
            if(!allowA.has(a.name)){
              if(a.name !== 'style') child.removeAttribute(a.name);
            }
          });
          if(tag === 'A'){
            const href = safeUrl(child.getAttribute('href'));
            if(!href){
              const frag2 = doc.createDocumentFragment();
              while(child.firstChild) frag2.appendChild(child.firstChild);
              child.replaceWith(frag2);
              continue;
            }
            child.setAttribute('href', href);
            child.setAttribute('target','_blank');
            child.setAttribute('rel','noopener noreferrer');
          }
          if(tag === 'IMG'){
            const src = safeUrl(child.getAttribute('src'));
            if(!src){ child.remove(); continue; }
            child.setAttribute('src', src);
            child.setAttribute('loading','lazy');
            child.removeAttribute('srcset');
          }
          if(child.hasAttribute('style')){
            const s = sanitizeStyle(child.getAttribute('style'));
            if(s) child.setAttribute('style', s);
            else child.removeAttribute('style');
          }
          walk(child);
        }else if(child.nodeType === 8){
          child.remove();
        }
      }
    };

    walk(wrap);
    return wrap.innerHTML;
  }

  function downloadText(fileName, text){
    const blob = new Blob([text], {type:'text/plain;charset=utf-8'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>{ try{ URL.revokeObjectURL(url); }catch(_e){} }, 1000);
  }

  function downloadBase64(fileName, base64, mime){
    mime = mime || 'application/octet-stream';
    const bin = atob(String(base64||''));
    const bytes = new Uint8Array(bin.length);
    for(let i=0;i<bin.length;i++) bytes[i] = bin.charCodeAt(i);
    const blob = new Blob([bytes], {type:mime});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(()=>{ try{ URL.revokeObjectURL(url); }catch(_e){} }, 1000);
  }

  // ===== Rich editor wiring =====
  function installRichEditor(toolbar, editor, opt){
    opt = opt || {};
    let savedRange = null;

    function saveRange(){
      try{
        const sel = window.getSelection();
        if(!sel || sel.rangeCount===0) return;
        savedRange = sel.getRangeAt(0).cloneRange();
      }catch(_e){}
    }
    function restoreRange(){
      try{
        if(!savedRange) return;
        const sel = window.getSelection();
        if(!sel) return;
        sel.removeAllRanges();
        sel.addRange(savedRange);
      }catch(_e){}
    }
    function focus(){ try{ editor && editor.focus(); }catch(_e){} }

    function wrapSelection(style){
      try{
        const sel = window.getSelection();
        if(!sel || sel.rangeCount===0) return false;
        const range = sel.getRangeAt(0);
        if(!range || range.collapsed) return false;
        const span = document.createElement('span');
        span.setAttribute('style', style);
        const frag = range.extractContents();
        span.appendChild(frag);
        range.insertNode(span);
        sel.removeAllRanges();
        const r2 = document.createRange();
        r2.setStartAfter(span);
        r2.collapse(true);
        sel.addRange(r2);
        editor.innerHTML = sanitizeRichHtml(editor.innerHTML);
        return true;
      }catch(_e){
        return false;
      }
    }
    function exec(cmd, val){
      try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
      try{ document.execCommand(cmd, false, val); }catch(_e2){}
      try{ if(editor) editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_eS){}
      try{ saveRange(); }catch(_e3){}
    }

    if(editor){
      editor.addEventListener('mouseup', saveRange);
      editor.addEventListener('keyup', saveRange);
      editor.addEventListener('keydown', (e) => {
        if(!(e.ctrlKey || e.metaKey) || e.altKey) return;
        const k = String(e.key||'').toLowerCase();
        if(k !== 'b' && k !== 'i' && k !== 'u') return;
        e.preventDefault();
        try{ saveRange(); }catch(_e){}
        try{ restoreRange(); }catch(_e2){}
        focus();
        if(k === 'b') exec('bold');
        else if(k === 'i') exec('italic');
        else exec('underline');
      });
      editor.addEventListener('touchend', saveRange);
editor.addEventListener('paste', (e) => {
        e.preventDefault();
        let t = '';
        try{ t = (e.clipboardData || window.clipboardData).getData('text/plain'); }catch(_e){}
        if(!t) return;
        exec('insertText', t);
      });
    }

    if(toolbar){
      toolbar.addEventListener('mousedown', (ev)=>{
        const t = ev.target && ev.target.closest ? ev.target.closest('button,select,input') : null;
        if(t){
          saveRange();
          try{ if(t.tagName === 'BUTTON') ev.preventDefault(); }catch(_e){}
        }
      });
      // Emoji picker (preset quick insert)
      let emojiDocBound = false;
      function closeEmoji_(){
        try{ toolbar.querySelectorAll('.slbEmojiPanel').forEach(p=>p.classList.add('hidden')); }catch(_e){}
      }
      function toggleEmoji_(btn){
        try{
          const wrap = btn && btn.closest ? btn.closest('.slbEmojiWrap') : null;
          const panel = wrap ? wrap.querySelector('.slbEmojiPanel') : null;
          if(!panel){ closeEmoji_(); return; }
          const wasOpen = !panel.classList.contains('hidden');
          closeEmoji_();
          if(wasOpen) return;
          panel.classList.remove('hidden');
          if(!emojiDocBound){
            emojiDocBound = true;
            document.addEventListener('click', (e)=>{
              try{
                if(!toolbar.contains(e.target)) return closeEmoji_();
                const w = e.target && e.target.closest ? e.target.closest('.slbEmojiWrap') : null;
                if(!w) closeEmoji_();
              }catch(_e){}
            }, true);
          }
        }catch(_e){}
      }

      toolbar.addEventListener('click', (ev) => {
        const btn = ev.target.closest('button');
        if(!btn) return;

        const wcolor = btn.getAttribute('data-wcolor');
        const wbg = btn.getAttribute('data-wbg');
        const emoji = btn.getAttribute('data-emoji');
        const cmd = String(btn.getAttribute('data-wcmd')||'');

        if(emoji){
          restoreRange();
          focus();
          closeEmoji_();
          exec('insertText', String(emoji));
          return;
        }

        if(cmd === 'emoji'){
          toggleEmoji_(btn);
          return;
        }

        closeEmoji_();
        restoreRange();
        focus();

        if(wcolor){
          const c = String(wcolor||'').trim();
          if(!c) return;
          if(!wrapSelection('color:' + c + ';')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('foreColor', false, c); }catch(_e2){}
            try{ if(editor) editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e3){}
          }
          return;
        }

        if(wbg){
          const c = String(wbg||'').trim();
          if(!c) return;
          if(!wrapSelection('background-color:' + c + ';')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('hiliteColor', false, c); }catch(_e2){
              try{ document.execCommand('backColor', false, c); }catch(_e3){}
            }
            try{ if(editor) editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e4){}
          }
          return;
        }

        if(!cmd) return;

        if(cmd === 'createLink'){
          const u = prompt('Link URL (https://...)');
          const su = safeUrl(u);
          if(!su) return;
          exec('createLink', su);
          return;
        }
        if(cmd === 'insertImage'){
          const u = prompt('Image URL (https://...)');
          const su = safeUrl(u);
          if(!su) return;
          exec('insertImage', su);
          return;
        }
        exec(cmd);
      });

      const color = opt.colorEl;
      if(color){
        color.addEventListener('mousedown', saveRange);
        color.addEventListener('change', () => {
          restoreRange();
          focus();
          const c = String(color.value||'').trim();
          if(!c) return;
          if(!wrapSelection('color:' + c + ';')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('foreColor', false, c); }catch(_e2){}
            try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e3){}
          }
        });
      }

      const hl = opt.hlEl;
      if(hl){
        hl.addEventListener('mousedown', saveRange);
        hl.addEventListener('change', () => {
          restoreRange();
          focus();
          const c = String(hl.value||'').trim();
          if(!c) return;
          if(!wrapSelection('background-color:' + c + ';')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('hiliteColor', false, c); }catch(_e2){
              try{ document.execCommand('backColor', false, c); }catch(_e3){}
            }
            try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e4){}
          }
        });
      }

      const size = opt.sizeEl;
      if(size){
        size.addEventListener('mousedown', saveRange);
        size.addEventListener('change', () => {
          restoreRange();
          focus();
          const n = Number(String(size.value||'').trim());
          if(!n) return;
          const px = Math.max(8, Math.min(48, Math.round(n)));
          if(!wrapSelection('font-size:' + px + 'px;')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('fontSize', false, '7'); }catch(_e2){}
            try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e3){}
          }
        });
      }

      const h = opt.headingEl;
      if(h){
        h.addEventListener('mousedown', saveRange);
        h.addEventListener('change', () => {
          restoreRange();
          focus();
          const v = String(h.value||'').trim();
          if(!v) return;
          if(v === 'p') exec('formatBlock', 'P');
          else if(v === 'h1') exec('formatBlock','H1');
          else if(v === 'h2') exec('formatBlock','H2');
          else if(v === 'h3') exec('formatBlock','H3');
          else if(v === 'h4') exec('formatBlock','H4');
        });
      }
    }

    return {
      sanitizeNow: () => { try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e){} },
      getHtml: () => sanitizeRichHtml(editor ? editor.innerHTML : ''),
      setHtml: (html) => { if(editor) editor.innerHTML = sanitizeRichHtml(html||''); },
      getText: () => String(editor ? (editor.innerText || editor.textContent || '') : '').trim()
    };
  }

  // ===== UI (main diary) =====
  function buildDiaryHtml(titleOrOpts){
    const opts = (titleOrOpts && typeof titleOrOpts === 'object') ? titleOrOpts : { title: titleOrOpts };
    const mode = String(opts.mode || 'user'); // 'user' | 'admin'
    const title = opts.title || (mode === 'admin' ? 'Diary (Admin)' : 'Daily Entry');

    // Admin diary page can have theme CSS that forces selects to full width.
    // Use inline styles (with !important) only for admin mode to guarantee compact selects.
    const admHeadingStyle = (mode === 'admin')
      ? ' style="width:220px!important;min-width:220px!important;max-width:220px!important;flex:0 0 auto!important;display:inline-block!important;"'
      : '';
    const admSizeStyle = (mode === 'admin')
      ? ' style="width:110px!important;min-width:110px!important;max-width:110px!important;flex:0 0 auto!important;display:inline-block!important;"'
      : '';

    const listTools = `
      <div class="row" style="align-items:flex-end;gap:10px;flex-wrap:wrap;">
        <div style="flex:1;min-width:200px;">
          <label>Search (tags + body)</label>
          <input id="slbDiarySearch" placeholder="Search..." />
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;">
          <button class="btn soft mini" id="slbDiaryRefresh" type="button">Refresh</button>
          <button class="btn soft mini" id="slbDiaryExportCsv" type="button">Export CSV</button>
          <button class="btn soft mini" id="slbDiaryExportZip" type="button">Export ZIP</button>
        </div>
      </div>

      <div class="hr" style="margin:12px 0;"></div>
    `;

    // User diary: move list tools down (just before list). Admin: keep list tools at the top.
    const topListTools = (mode === 'user') ? '' : listTools;
    const bottomListTools = (mode === 'user') ? listTools : '';

    // User Diary UI: 2 collapsable boxes (Write / Read). Both collapsed by default.
    if(mode === 'user'){
      return `
        <div class="slbFold" id="slbDiaryFoldWrite">
          <div class="slbFoldHeader">
            <div class="slbFoldTitle">Write</div>
            <button class="btn soft mini slbFoldBtn" data-fold="write" type="button">Open</button>
          </div>
	          <div class="slbFoldBody hidden" id="slbDiaryWriteBody">

            <div class="row" style="gap:10px;flex-wrap:wrap;">
              <div style="min-width:160px;">
                <label>Date</label>
                <input id="slbDiaryDate" type="date" />
              </div>
              <div style="flex:1;min-width:200px;">
                <label>Tags / keywords</label>
                <input id="slbDiaryTags" placeholder="e.g. AC, protection, lesson" />
              </div>
            </div>

            <style id="slbDiarySplitFixCss">
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbDiarySplitPane,.slbDiarySplitPaneLeft,.slbDiarySplitPaneRight){background:var(--slb-panel,#0f1517)!important;color:var(--slb-text,#e8eef2)!important;border-color:rgba(255,255,255,.14)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbDiarySplitHead){background:var(--slb-panel-2,#151c20)!important;color:var(--slb-text,#e8eef2)!important;border-bottom-color:rgba(255,255,255,.12)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbDiarySplitBody,#slbDiaryPrevReplyMeta,#slbDiaryPrevReplyBody){background:var(--slb-panel,#0f1517)!important;color:var(--slb-text,#e8eef2)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) .slbDiarySplitIntro{color:var(--slb-text-muted,#aab6c0)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbDiaryReadPane){background:var(--slb-panel,#0f1517)!important;color:var(--slb-text,#e8eef2)!important;border-color:rgba(255,255,255,.14)!important;}
:root[data-slb-theme="dark"] :is(#SaamLawBank,#tyWealthCourtyard) :is(.slbDiaryReadPaneBody){background:var(--slb-panel-2,#151c20)!important;color:var(--slb-text,#e8eef2)!important;border-color:rgba(255,255,255,.12)!important;}
@media (max-width: 900px){.slbDiarySplitGrid,.slbDiaryReadSplit{grid-template-columns:1fr!important;}}
</style>

            <div class="slbDiarySplitIntro" style="margin-top:10px;margin-bottom:10px;color:#6b7680;font-size:13px;">Left shows the latest reply from your Si Juen. Type your new entry on the right.</div>

            <div class="slbDiarySplitGrid" style="display:grid;grid-template-columns:minmax(260px,1fr) minmax(320px,1.35fr);gap:12px;align-items:start;">
              <div class="slbDiarySplitPane slbDiarySplitPaneLeft" style="border:1px solid rgba(226,230,234,.95);border-radius:14px;background:var(--slb-panel,#fff);color:var(--slb-text,#0f1517);overflow:hidden;min-width:0;">
                <div class="slbDiarySplitHead" style="padding:10px 12px;border-bottom:1px solid rgba(226,230,234,.95);font-weight:800;background:var(--slb-panel-2,#f7f7f7);color:var(--slb-text,#0f1517);">Reply from Si Juen from yesterday</div>
                <div id="slbDiaryPrevReplyMeta" class="slbDiarySplitMeta" style="padding:8px 12px 0;color:var(--slb-text-muted,#6b7680);font-size:12px;"></div>
                <div id="slbDiaryPrevReplyBody" class="slbDiarySplitBody" style="padding:10px 12px 14px;min-height:220px;white-space:normal;word-break:break-word;background:var(--slb-panel,#fff);color:var(--slb-text,#0f1517);"><div class="muted">No reply from Si Juen from yesterday yet.</div></div>
              </div>

              <div class="slbDiarySplitPane slbDiarySplitPaneRight" style="min-width:0;">
                <label style="margin-top:0;">Your new entry</label>

            <div class="slbStdEditor" data-slbeditor="v1" id="slbDiaryStdEditor" data-slbeditor-height="360">
              <div class="slbWysToolbar slbStdToolbar">
                <div class="slbWysRow">
                  <div class="slbWysGroup">
                    <select class="inp" data-wys-heading style="width:160px;">
                      <option value="p">Paragraph</option>
                      <option value="h1">H1</option>
                      <option value="h2">H2</option>
                      <option value="h3">H3</option>
                      <option value="h4">H4</option>
                    </select>
                    <select class="inp" data-wys-size style="width:110px;">
                      <option value="12">12</option>
                      <option value="14">14</option>
                      <option value="16">16</option>
                      <option value="18">18</option>
                      <option value="20">20</option>
                      <option value="24" selected>24</option>
                      <option value="28">28</option>
                      <option value="32">32</option>
                      <option value="40">40</option>
                    </select>
                  </div>

                  <div class="slbWysGroup">
                    <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
                    <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
                    <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
                    <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
                  </div>

                  <div class="slbWysGroup slbWysAdvGroup">
                    <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>
                    <button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>
                    <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
                    <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>
                    <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
                    <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
                    <button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>
                  </div>

                  <div class="slbWysGroup slbWysMoreGroup">
                    <button class="btn soft mini slbWysMoreBtn" type="button" data-wcmd="more" title="More tools" aria-pressed="false">⋯</button>
                  </div>
                </div>

                <div class="slbWysRow">
                  <div class="slbWysGroup">
                    <button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>
                    <button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>
                    <button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>
                    <button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>
                    <button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>
                    <input type="color" class="inp" data-wys-colorpicker style="width:36px;padding:0;" />
                  </div>

                  <div class="slbWysGroup">
                    <button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>
                    <button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>
                    <button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>
                    <button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>
                    <button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>
                    <input type="color" class="inp" data-wys-hlpicker style="width:36px;padding:0;" />
                  </div>

                  <div class="slbWysGroup slbEmojiWrap">
                    <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>
                    <div class="slbEmojiPanel hidden">
                      <button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>
                      <button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>
                      <button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>
                      <button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>
                      <button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>
                      <button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>
                      <button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>
                      <button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>
                      <button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>
                      <button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>
                      <button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>
                      <button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>
                      <button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>
                      <button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>
                      <button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>
                      <button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>
                      <button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>
                    </div>
                  </div>

                  <div class="slbWysGroup slbWysEnd">
                    <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
                    <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>
                    <button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>
                    <button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>
                  </div>
                </div>
              </div>

              <div id="slbDiaryBodyRich" class="richEditor slbStdArea" data-slbeditor-area contenteditable="true" spellcheck="true"></div>
            </div>
              </div>
            </div>

            <div id="slbDiaryWordCounter" class="slbWordCounter"></div>

            <div class="slbDiaryActionRow">
              <div class="slbDiaryActionStatus">
                <div class="err hidden" id="slbDiaryErr"></div>
                <div class="ok hidden" id="slbDiaryOk"></div>
              </div>
              <div class="slbDiaryActionButtons">
                <button class="btn soft" id="slbDiarySave" type="button" title="Save a local backup on this device">Save</button>
                <button class="btn orange slbDiarySubmitBtn" id="slbDiarySubmit" type="button">Submit</button>
              </div>
            </div>
          </div>
        </div>

        <div class="slbFold" id="slbDiaryFoldRead" style="margin-top:12px;">
          <div class="slbFoldHeader">
            <div class="slbFoldTitle">Read</div>
            <button class="btn soft mini slbFoldBtn" data-fold="read" type="button">Open</button>
          </div>
	          <div class="slbFoldBody hidden" id="slbDiaryReadBoxBody">
	            <div id="slbDiaryRead" class="slbDiaryRead">
	              <div class="slbDiaryReadWrap">
	                <div class="slbDiaryReadLeft">
	                  <div id="slbDiaryReadList" class="slbDiaryReadList"></div>
	                </div>
	                <div class="slbDiaryReadRight">
	                  <div class="slbDiaryReadRightTop">
	                    <div id="slbDiaryReadMeta" class="slbDiaryReadMeta">Select a date to read.</div>
	                    <div class="slbDiaryReadBtns">
	                      <button class="btn orange mini" id="slbDiaryReadEmailBtn" type="button" disabled>&gt;&gt; Si Juen</button>
                      <button class="btn soft mini" id="slbDiaryReadRefreshBtn" type="button" disabled>Refresh</button>
	                      <button class="btn soft mini" id="slbDiaryReadEditBtn" type="button" disabled>Edit</button>
	                      <button class="btn danger mini" id="slbDiaryReadDeleteBtn" type="button" disabled>Delete</button>
	                    </div>
	                  </div>
	                  <div class="slbDiaryReadSearchRow" style="margin-top:10px;">
	                    <input id="slbDiaryReadSearch" placeholder="Search in Read..." />
	                  </div>
	                  <div id="slbDiaryReadBody" class="slbDiaryReadBody"></div>
	                </div>
	              </div>
	            </div>
	          </div>
        </div>

      `;
    }

    return `
      ${topListTools}

      <h3 style="margin:0 0 8px;font-size:20px;font-weight:900;">${esc(title||'Daily Entry')}</h3>
      <div class="row" style="gap:10px;flex-wrap:wrap;">
        <div style="min-width:160px;">
          <label>Date</label>
          <input id="slbDiaryDate" type="date" />
        </div>
        <div style="flex:1;min-width:200px;">
          <label>Tags / keywords</label>
          <input id="slbDiaryTags" placeholder="e.g. AC, protection, lesson" />
        </div>
      </div>

      <label style="margin-top:10px;">Entry</label>
      <div class="slbWysToolbar" id="slbDiaryWysToolbar">
        <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
        <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
        <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
        <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
        <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList">• List</button>
        <button class="btn soft mini" type="button" data-wcmd="insertOrderedList">1. List</button>
        <button class="btn soft mini" type="button" data-wcmd="formatBlock" data-wval="BLOCKQUOTE">Quote</button>
        <button class="btn soft mini" type="button" data-wcmd="createLink">Link</button>
        <button class="btn soft mini" type="button" data-wcmd="insertImage">Image</button>

        <span class="slbWysRow slbWysRowTop">
          <select id="slbDiaryHeading" class="slbWysSelect slbWysHeadingSel" title="Heading / style"${admHeadingStyle}>
            <option value="">Heading</option>
            <option value="p">Paragraph</option>
            <option value="h1">H1</option>
            <option value="h2">H2</option>
            <option value="h3">H3</option>
            <option value="h4">H4</option>
          </select>

          <select id="slbDiaryWysSize" class="slbWysSelect slbWysSizeSel" title="Font size"${admSizeStyle}>
            <option value="">Size</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
            <option value="18">18</option>
            <option value="24">24</option>
            <option value="32">32</option>
            <option value="40">40</option>
          </select>

          <span class="slbEmojiWrap">
            <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emoji">😊</button>
            <div class="slbEmojiPanel hidden" data-emoji-panel="1">
              <button class="slbEmojiItem" type="button" data-emoji="✅" title="Check">✅</button>
              <button class="slbEmojiItem" type="button" data-emoji="☑️" title="Checkbox checked">☑️</button>
              <button class="slbEmojiItem" type="button" data-emoji="⬛" title="Square">⬛</button>
              <button class="slbEmojiItem" type="button" data-emoji="❤️" title="Heart">❤️</button>
              <button class="slbEmojiItem" type="button" data-emoji="💡" title="Idea">💡</button>
              <button class="slbEmojiItem" type="button" data-emoji="⚡" title="Lightning">⚡</button>
              <button class="slbEmojiItem" type="button" data-emoji="❌" title="X">❌</button>
              <button class="slbEmojiItem" type="button" data-emoji="🚫" title="No">🚫</button>
              <button class="slbEmojiItem" type="button" data-emoji="👍" title="Thumbs up">👍</button>
              <button class="slbEmojiItem" type="button" data-emoji="👎" title="Thumbs down">👎</button>
              <button class="slbEmojiItem" type="button" data-emoji="😀" title="Happy">😀</button>
              <button class="slbEmojiItem" type="button" data-emoji="🙂" title="Smile">🙂</button>
              <button class="slbEmojiItem" type="button" data-emoji="😐" title="Neutral">😐</button>
              <button class="slbEmojiItem" type="button" data-emoji="😕" title="Confused">😕</button>
              <button class="slbEmojiItem" type="button" data-emoji="😢" title="Sad">😢</button>
              <button class="slbEmojiItem" type="button" data-emoji="😭" title="Crying">😭</button>
              <button class="slbEmojiItem" type="button" data-emoji="😡" title="Angry">😡</button>
              <button class="slbEmojiItem" type="button" data-emoji="😱" title="Shock">😱</button>
              <button class="slbEmojiItem" type="button" data-emoji="🤔" title="Thinking">🤔</button>
              <button class="slbEmojiItem" type="button" data-emoji="⭐️" title="Star">⭐️</button>
              <button class="slbEmojiItem" type="button" data-emoji="🔥" title="Fire">🔥</button>
              <button class="slbEmojiItem" type="button" data-emoji="📝" title="Note">📝</button>
              <button class="slbEmojiItem" type="button" data-emoji="📌" title="Pin">📌</button>
            </div>
          </span>

          <button class="btn soft mini" type="button" data-wcmd="removeFormat">Clear</button>
        </span>

        <span class="slbWysRow slbWysRowColors">
          <span class="slbWysGroup">
            <span class="slbWysLabel">Text</span>
            <input id="slbDiaryWysColor" type="color" class="slbWysColorInput" title="Text color" />
            <span class="slbWysSwatches" title="Quick text colors">
              <button class="slbSwatch" type="button" data-wcolor="#ef4444" title="Red" style="background:#ef4444;"></button>
              <button class="slbSwatch" type="button" data-wcolor="#3b82f6" title="Blue" style="background:#3b82f6;"></button>
              <button class="slbSwatch" type="button" data-wcolor="#a855f7" title="Purple" style="background:#a855f7;"></button>
              <button class="slbSwatch" type="button" data-wcolor="#22c55e" title="Green" style="background:#22c55e;"></button>
              <button class="slbSwatch" type="button" data-wcolor="#f97316" title="Orange" style="background:#f97316;"></button>
              <button class="slbSwatch" type="button" data-wcolor="#111827" title="Black" style="background:#111827;"></button>
            </span>
          </span>

          <span class="slbWysGroup">
            <span class="slbWysLabel">Highlight</span>
            <input id="slbDiaryWysHl" type="color" class="slbWysColorInput" title="Highlight" />
            <span class="slbWysSwatches" title="Quick highlight">
              <button class="slbSwatch" type="button" data-wbg="#fef08a" title="Yellow highlight" style="background:#fef08a;"></button>
              <button class="slbSwatch" type="button" data-wbg="#bbf7d0" title="Green highlight" style="background:#bbf7d0;"></button>
              <button class="slbSwatch" type="button" data-wbg="#bfdbfe" title="Blue highlight" style="background:#bfdbfe;"></button>
              <button class="slbSwatch" type="button" data-wbg="#fed7aa" title="Orange highlight" style="background:#fed7aa;"></button>
              <button class="slbSwatch" type="button" data-wbg="#e9d5ff" title="Purple highlight" style="background:#e9d5ff;"></button>
              <button class="slbSwatch" type="button" data-wbg="#fbcfe8" title="Pink highlight" style="background:#fbcfe8;"></button>
            </span>
          </span>
        </span>
      </div>

      <div class="slbRichWrap">
        <div id="slbDiaryBodyRich" class="richEditor" contenteditable="true" spellcheck="true"></div>
        <div id="slbDiaryWordCounter" class="slbWordCounter"></div>
      </div>

      <div style="margin-top:10px;display:flex;gap:8px;flex-wrap:wrap;align-items:center;">
        <button class="btn orange" id="slbDiarySave" type="button">Save</button>
        <div class="err hidden" id="slbDiaryErr" style="margin:0;"></div>
        <div class="ok hidden" id="slbDiaryOk" style="margin:0;"></div>
      </div>

      ${bottomListTools}

      <div id="slbDiaryList"></div>
      <div style="margin-top:10px;display:flex;gap:8px;align-items:center;">
        <button class="btn soft mini hidden" id="slbDiaryMore" type="button">Load more</button>
      </div>

      ${mode === 'user' ? `
        <hr class="slbDiaryReadHr" />
        <div id="slbDiaryRead" class="slbDiaryRead">
          <div class="slbDiaryReadTitle">Diary Read</div>
          <div class="slbDiaryReadWrap">
            <div class="slbDiaryReadLeft">
              <div id="slbDiaryReadList" class="slbDiaryReadList"></div>
            </div>
            <div class="slbDiaryReadRight">
              <div id="slbDiaryReadMeta" class="slbDiaryReadMeta">Select a date to read.</div>
              <div id="slbDiaryReadBody" class="slbDiaryReadBody"></div>
            </div>
          </div>
        </div>
      ` : ''}

    `;
  }

  

  function mergeByDateKey_(a, b){
    const map = new Map();
    const richness = (it)=>{
      if(!it) return 0;
      let n = 0;
      if(String(it.bodyRich||'').trim()) n += 2;
      if(String(it.userBodyRich||'').trim()) n += 2;
      if(String(it.adminReplyRich||'').trim()) n += 2;
      if(String(it.body||it.userBody||'').trim()) n += 1;
      if(String(it.adminReply||'').trim()) n += 1;
      return n;
    };
    const put = (it)=>{
      if(!it) return;
      const dk = String(it.dateKey||'').trim();
      if(!dk) return;
      const prev = map.get(dk);
      if(!prev){ map.set(dk, it); return; }
      const ua = String(it.updatedAt||'');
      const ub = String(prev.updatedAt||'');
      if(ua && ub){
        if(ua > ub || (ua === ub && richness(it) >= richness(prev))) map.set(dk,it);
        return;
      }
      if(richness(it) >= richness(prev)) map.set(dk,it);
    };
    (a||[]).forEach(put);
    (b||[]).forEach(put);
    const arr = Array.from(map.values());
    arr.sort((x,y)=>String(y.dateKey||'').localeCompare(String(x.dateKey||'')));
    return arr;
  }

  function itemPreviewPlain_(it){
    if(!it) return '';
    const p = String(it.userBodyPlain||it.bodyPlain||'').trim();
    if(p) return p;
    const r = String(it.userBodyRich||it.bodyRich||'').trim();
    if(r) return htmlToPlain(r);
    const b = String(it.userBody||it.body||'').trim();
    return looksLikeBbcode(b) ? bbcodeToPlain(b) : b;
  }

  function itemAdminReplyHtml_(it){
    if(!it) return '';
    const htmlRaw = String((it.adminReplyRich!=null && it.adminReplyRich!==undefined) ? it.adminReplyRich : '').trim();
    const bodyRaw = String((it.adminReply!=null && it.adminReply!==undefined) ? it.adminReply : '').trim();
    return htmlRaw ? toHtmlMaybe(htmlRaw) : (bodyRaw ? toHtmlMaybe(bodyRaw) : '');
  }

  function itemUserHtml_(it){
    if(!it) return '';
    const htmlRaw = String((it.userBodyRich!=null && it.userBodyRich!==undefined) ? it.userBodyRich : (it.bodyRich!=null ? it.bodyRich : '')).trim();
    const bodyRaw = String((it.userBody!=null && it.userBody!==undefined) ? it.userBody : (it.body!=null ? it.body : '')).trim();
    return htmlRaw ? toHtmlMaybe(htmlRaw) : (bodyRaw ? toHtmlMaybe(bodyRaw) : '');
  }

  function findLatestAdminReplyBefore_(items, dateKey){
    const dk = String(dateKey||'').trim();
    const arr = (items||[]).slice().sort((a,b)=>String(b.dateKey||'').localeCompare(String(a.dateKey||'')));
    for(const it of arr){
      const idk = String(it && it.dateKey || '').trim();
      if(!idk) continue;
      if(dk && idk >= dk) continue;
      if(itemAdminReplyHtml_(it)) return it;
    }
    return arr.find(it => itemAdminReplyHtml_(it)) || null;
  }


  function prevDateKey_(dk, daysBack){
    try{
      const m = String(dk||'').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if(!m) return '';
      const dt = new Date(Date.UTC(Number(m[1]), Number(m[2])-1, Number(m[3])));
      dt.setUTCDate(dt.getUTCDate() - Math.max(1, Number(daysBack)||1));
      const y = dt.getUTCFullYear();
      const mo = String(dt.getUTCMonth()+1).padStart(2,'0');
      const da = String(dt.getUTCDate()).padStart(2,'0');
      return y + '-' + mo + '-' + da;
    }catch(_e){ return ''; }
  }

  async function syncPrevReplyForDate_(dateKey, currentItem){
    const token = ++state._prevReplyToken;
    try{
      const bodyEl = $('slbDiaryPrevReplyBody');
      const metaEl = $('slbDiaryPrevReplyMeta');
      if(!bodyEl) return;
      const dk = String(dateKey||'').trim();
      if(metaEl) metaEl.textContent = '';
      if(!dk){
        bodyEl.innerHTML = '<div class="muted">No reply from Si Juen from yesterday yet.</div>';
        return;
      }
      const yk = prevDateKey_(dk, 1);
      if(!yk){
        bodyEl.innerHTML = '<div class="muted">No reply from Si Juen from yesterday yet.</div>';
        return;
      }
      const renderSrc = (src, loading)=>{
        if(token !== state._prevReplyToken) return;
        const html = src ? itemAdminReplyHtml_(src) : '';
        if(html){
          const metaBits = ['Showing reply from yesterday', 'Reply date: <b>' + esc(yk) + '</b>'];
          const srcTime = fmtTimeToronto(src.adminReplyAt || src.updatedAt || src.createdAt);
          if(srcTime) metaBits.push('Updated: <b>' + esc(srcTime) + '</b>');
          if(metaEl) metaEl.innerHTML = metaBits.join(' · ');
          bodyEl.innerHTML = html;
        }else if(loading){
          bodyEl.innerHTML = '<div class="muted">Checking yesterday\'s reply...</div>';
        }else{
          if(metaEl) metaEl.textContent = '';
          bodyEl.innerHTML = '<div class="muted">No reply from Si Juen from yesterday yet.</div>';
        }
      };
      const cached = (state.items || []).find(it => String(it && it.dateKey || '').trim() === yk) || null;
      renderSrc(cached, !cached);
      try{
        const res = await rpc('diaryGet', { dateKey: yk });
        if(token !== state._prevReplyToken) return;
        const out = res && (res.result || res);
        const src = out && out.item ? out.item : null;
        if(src){
          state.items = mergeByDateKey_(state.items, [src]);
          saveCache_();
        }
        renderSrc(src || cached, false);
      }catch(_e){
        renderSrc(cached, false);
      }
    }catch(_e){
      try{
        const bodyEl = $('slbDiaryPrevReplyBody');
        const metaEl = $('slbDiaryPrevReplyMeta');
        if(metaEl) metaEl.textContent = '';
        if(bodyEl) bodyEl.innerHTML = '<div class="muted">No reply from Si Juen from yesterday yet.</div>';
      }catch(__e){}
    }
  }


  // viewer container for error/status UI
  var elViewer = null;

function showEl(el, on){ if(!el) return; el.classList.toggle('hidden', !on); }
  function setErr(msg, withRetry){
    if(!elViewer) return;
    let box = elViewer.querySelector('#slbDiaryErrBox');
    const btn = withRetry ? '<button class="slbMiniBtn is-orange" type="button" onclick="__slbDiaryRetry()">Retry</button>' : '';
    if(!box){
      if(!msg) return;
      elViewer.insertAdjacentHTML('beforeend',
        '<div id="slbDiaryErrBox" class="slbErrBox" style="margin-top:10px;">'
        + '<div class="t">Error</div><div class="b">'+esc(msg)+'</div>' + btn +
        '</div>'
      );
      return;
    }
    if(!msg){
      box.style.display = 'none';
      box.innerHTML = '';
      return;
    }
    box.className = 'slbErrBox';
    box.innerHTML = '<div class="t">Error</div><div class="b">'+esc(msg)+'</div>' + btn;
    box.style.display = 'block';
  }
  function setOk(msg){
    const e = $('slbDiaryErr');
    const o = $('slbDiaryOk');
    if(e) showEl(e,false);
    if(o){ o.textContent = String(msg||''); showEl(o, !!msg); }
  }

  
  function injectDiaryReadCss_(){
    try{
      if(document.getElementById('slbDiaryReadCss')) return;
      const css = `
        .slbDiaryReadHr{ border:0; border-top:1px solid rgba(226,230,234,.9); margin:18px 0 12px; }
        .slbDiaryRead{ --ty-orange:#ef5e14; --ty-border:#e2e6ea; --ty-muted:#6b7680; }
        .slbDiaryReadTitle{ font-weight:900; font-size:16px; margin:0 0 10px; }
        .slbDiaryReadWrap{ display:grid; grid-template-columns: 190px 1fr; gap:12px; align-items:start; }
        .slbDiaryReadLeft{ border:1px solid var(--ty-border); border-radius:14px; background:#fff; overflow:hidden; }
        .slbDiaryReadList{ max-height:260px; overflow:auto; }
        .slbDiaryReadItem{ display:flex; justify-content:space-between; align-items:center; gap:10px; padding:10px 12px; border:none; width:100%; background:transparent; text-align:left; border-radius:0; cursor:pointer; }
        .slbDiaryReadItem:nth-child(even){ background: rgba(239,94,20,.035); }
        .slbDiaryReadItem:hover{ background: rgba(239,94,20,.07); }
        .slbDiaryReadItem.is-active{ outline:2px solid rgba(239,94,20,.35); background: rgba(239,94,20,.10); }
        .slbDiaryReadItem .dk{ font-weight:800; }
        .slbDiaryReadItem .age{ color: var(--ty-orange); font-size:12px; font-weight:900; }
        .slbDiaryReadRight{ border:1px solid var(--ty-border); border-radius:14px; background:#fff; padding:12px; min-width:0; }
        .slbDiaryReadRightTop{ display:flex; justify-content:space-between; align-items:flex-start; gap:10px; flex-wrap:wrap; }
        .slbDiaryReadBtns{ display:flex; gap:6px; flex-wrap:wrap; align-items:center; }
        .slbDiaryReadSep{ border-top:1px solid var(--ty-border); margin:14px 0 8px; }
        .slbDiaryReadTags{ font-size:12px; color:var(--ty-muted); }

        .slbDiaryReadMeta{ color: var(--ty-muted); font-size:12px; }
        .slbDiaryReadSearchRow input{ width:100%; border:1px solid var(--ty-border); border-radius:999px; padding:10px 12px; font-size:14px; outline:none; }
        .slbDiaryReadBody{ margin-top:8px; overflow-wrap:anywhere; word-break:break-word; }

        @media(max-width:720px){
          .slbDiaryReadWrap{ grid-template-columns:1fr; }
          .slbDiaryReadLeft{ border:none; background:transparent; }
          .slbDiaryReadList{
            display:flex;
            gap:8px;
            overflow-x:auto;
            overflow-y:hidden;
            max-height:none;
            padding:8px 2px;
            -webkit-overflow-scrolling: touch;
          }
          .slbDiaryReadItem{
            flex:0 0 auto;
            border:1px solid var(--ty-border);
            border-radius:999px;
            background:#fff;
            padding:8px 10px;
          }
          .slbDiaryReadItem:nth-child(even){ background:#fff; }
        }
      `;
      const st = document.createElement('style');
      st.id = 'slbDiaryReadCss';
      st.textContent = css;
      document.head.appendChild(st);
    }catch(_e){}
  }

function mountMain(){
    const panel = $('slbDiaryPanel');
    if(!panel) return false;
    // A previous early boot may have happened before the SLB callsign was ready.
    // Only treat the panel as mounted when the real Diary controls exist.
    if(panel.__slbDiaryMounted && $('slbDiaryRefresh')) return true;
    if(panel.__slbDiaryMounted && !$('slbDiaryRefresh')) panel.__slbDiaryMounted = false;

    const role = getRole();
    if(!role.callsign){
      panel.__slbDiaryMounted = false;
      panel.__slbDiaryWaitingAuth = true;
      panel.innerHTML = '<div class="muted" style="margin-top:8px;">Diary is preparing…</div>';
      return false;
    }
    panel.__slbDiaryMounted = true;
    panel.__slbDiaryWaitingAuth = false;

    // Phase C: remember last opened entry in Read mode
    const LS_LAST_DK = 'slb_diary_last_dk_v1_' + String((role && role.callsign) ? role.callsign : 'anon').toUpperCase();
    function lsGet_(k){ try{ return localStorage.getItem(k); }catch(_e){ return null; } }
    function lsSet_(k,v){ try{ localStorage.setItem(k, String(v==null?'':v)); }catch(_e){} }
    panel.innerHTML = buildDiaryHtml({ title: 'Daily Entry', mode: 'user' });
    injectDiaryReadCss_();

	    
    elViewer = panel;

    // V4.14: the history refresh timer exists only while Read is actually visible.
    // This removes a permanent background interval from users who never open Diary Read.
    function stopReadRefreshTimer_(){
      try{ if(panel.__slbDiaryReadRefreshTimer) clearInterval(panel.__slbDiaryReadRefreshTimer); }catch(_e){}
      panel.__slbDiaryReadRefreshTimer = 0;
    }
    function startReadRefreshTimer_(){
      stopReadRefreshTimer_();
      try{ if(document.hidden) return; }catch(_eHidden){}
      panel.__slbDiaryReadRefreshTimer = setInterval(()=>{
        try{
          if(document.hidden){ stopReadRefreshTimer_(); return; }
          loadList(false).catch(()=>{});
        }catch(_e){}
      }, 600000);
    }

// Collapsable boxes (Write / Read)
	    const fold = (function(){
	      const wBody = $('slbDiaryWriteBody');
	      const rBody = $('slbDiaryReadBoxBody');
	      const wBtn = panel.querySelector('button[data-fold="write"]');
	      const rBtn = panel.querySelector('button[data-fold="read"]');
	      const wHeader = panel.querySelector('#slbDiaryFoldWrite .slbFoldHeader');
	      const rHeader = panel.querySelector('#slbDiaryFoldRead .slbFoldHeader');
	      if(!wBody || !rBody || !wBtn || !rBtn){
	        return { open: ()=>{}, close: ()=>{}, isOpen: ()=>true };
	      }
	      function set_(which, open){
	        const body = (which === 'write') ? wBody : rBody;
	        const btn = (which === 'write') ? wBtn : rBtn;
	        const isOpen = !body.classList.contains('hidden');
	        if(open === isOpen) return;
	        if(open) body.classList.remove('hidden');
	        else body.classList.add('hidden');
        if(which === 'read'){
          if(open) startReadRefreshTimer_();
          else stopReadRefreshTimer_();
        }
	        btn.textContent = open ? 'Close' : 'Open';
	        try{ btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }catch(_e){}
	      }
	      wBtn.addEventListener('click', ()=>{
	        const open = wBody.classList.contains('hidden');
	        set_('write', open);
	        if(open) set_('read', false);
	      });
	      if(wHeader){
	        wHeader.addEventListener('click', (ev)=>{
	          // Make the whole grey bar clickable, but don't double-trigger when clicking the button.
	          if(ev && ev.target && ev.target.closest && ev.target.closest('button')) return;
	          try{ wBtn.click(); }catch(_e){
	            const open = wBody.classList.contains('hidden');
	            set_('write', open);
	            if(open) set_('read', false);
	          }
	        });
	      }
	      rBtn.addEventListener('click', ()=>{
	        const open = rBody.classList.contains('hidden');
	        set_('read', open);
	        if(open) set_('write', false);
	      });
	      if(rHeader){
	        rHeader.addEventListener('click', (ev)=>{
	          if(ev && ev.target && ev.target.closest && ev.target.closest('button')) return;
	          try{ rBtn.click(); }catch(_e){
	            const open = rBody.classList.contains('hidden');
	            set_('read', open);
	            if(open) set_('write', false);
	          }
	        });
	      }
	      // default: both collapsed
	      set_('write', false);
	      set_('read', false);
	      return {
	        open: (which)=>set_(which, true),
	        close: (which)=>set_(which, false),
	        isOpen: (which)=>!((which==='write'?wBody:rBody).classList.contains('hidden'))
	      };
	    })();

	    // Phase 3: Mobile UX
	    // - On mobile, keep Write collapsed until user taps Open (better reading on-the-go).
	    // - On desktop, open Write by default.
	    try{
	      const isMobile = (window.matchMedia && window.matchMedia('(max-width: 520px)').matches);
	      if(!isMobile){
	        try{ fold.open('write'); }catch(_e0){}
	        try{ fold.close('read'); }catch(_e1){}
	      }
	    }catch(_e3){}

const dateEl = $('slbDiaryDate');
    const tagsEl = $('slbDiaryTags');
    const editor = $('slbDiaryBodyRich');
    const stdRoot = $('slbDiaryStdEditor');
    let toolbar = null;

    // Bind global editor if present; fallback to legacy toolbar binding (admin mode / older HTML).
    let rich = null;
    if(stdRoot && window.SLB_STD_EDITOR_V1 && typeof window.SLB_STD_EDITOR_V1.bind === 'function'){
      try{ window.SLB_STD_EDITOR_V1.bind(stdRoot); }catch(_e){}
      rich = {
        sanitizeNow: () => { try{ if(editor) editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e){} },
        getHtml: () => sanitizeRichHtml(editor ? editor.innerHTML : ''),
        setHtml: (html) => { if(editor) editor.innerHTML = sanitizeRichHtml(html||''); },
        getText: () => String(editor ? (editor.innerText || editor.textContent || '') : '').trim()
      };
    } else {
      toolbar = $('slbDiaryWysToolbar');
      const colorEl = $('slbDiaryWysColor');
      const sizeEl = $('slbDiaryWysSize');
      const headingEl = $('slbDiaryHeading');
      const hlEl = $('slbDiaryWysHl');
      rich = installRichEditor(toolbar, editor, { colorEl, hlEl, sizeEl, headingEl });
    }

    // Word/char counter: keep the typing hot path DOM-only. Rich HTML is
    // sanitized only when it actually leaves the editor (submit/restore), not per key.
    const wcEl = $('slbDiaryWordCounter');
    const WC_MAX_CHARS = 45000;
    let _wcRaf = 0;
    function updateWordCounter_(){
      if(!wcEl) return;
      const text = String(editor ? (editor.innerText || editor.textContent || '') : '');
      const rawHtml = String(editor ? (editor.innerHTML || '') : '');
      const plainChars = text.length;
      const richChars = rawHtml.length;
      const left = Math.max(0, WC_MAX_CHARS - richChars);
      const over = Math.max(0, richChars - WC_MAX_CHARS);
      wcEl.textContent = over > 0
        ? ('Rich ' + richChars + '/' + WC_MAX_CHARS + ' · OVER ' + over + ' · Text ' + plainChars)
        : ('Rich ' + richChars + '/' + WC_MAX_CHARS + ' · ' + left + ' left · Text ' + plainChars);
    }
    function scheduleWordCounter_(){
      if(_wcRaf) return;
      const run = ()=>{ _wcRaf = 0; updateWordCounter_(); };
      try{ _wcRaf = requestAnimationFrame(run); }catch(_e){ _wcRaf = setTimeout(run, 0); }
    }
    if(editor){
      editor.addEventListener('input', ()=>{ scheduleWordCounter_(); scheduleDraftSave_(); });
      editor.addEventListener('blur', ()=>{ updateWordCounter_(); saveDraftNow_(); });
    }
    if(tagsEl){
      tagsEl.addEventListener('input', ()=>scheduleDraftSave_());
      tagsEl.addEventListener('blur', ()=>saveDraftNow_());
    }
    updateWordCounter_();

    // quote: use formatBlock=BLOCKQUOTE button
    if(toolbar){
      toolbar.addEventListener('click', (ev)=>{
        const b = ev.target.closest('button[data-wcmd]');
        if(!b) return;
        const cmd = String(b.getAttribute('data-wcmd')||'');
        const val = String(b.getAttribute('data-wval')||'');
        if(cmd === 'formatBlock' && val){
          try{ document.execCommand('formatBlock', false, val); }catch(_e){}
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
        }
      }, true);
    }

    // default date = today (Toronto)
    try{ dateEl.value = torontoDateKey(new Date()); }catch(_e){}
    try{ renderPrevReply_(null, String(dateEl && dateEl.value || '').trim()); }catch(_e0){}

    const state = {
      q: '',
      beforeDateKey: '',
      hasMore: false,
      items: [],
      loadedDateKey: '',
      loadedHadExisting: false,
	      _autoInitDone: false,
	      readQ: '',
	      _syncing: false,
	      _lastSyncAt: 0,
	      _initialWriteHydrated: false,
      _writeFetchToken: 0,
      _prevReplyToken: 0,
      nextBeforeDateKey: ''
    };

	    // local cache (snappy READ)
	    const LS_KEY = 'slb_diary_cache_v2_' + String(role.callsign||'').trim().toUpperCase();
    function cachePack_(items){
      // Keep recent rich copies, but cap older text so a long diary cannot silently
      // overflow localStorage and disable the cache entirely.
      return (items||[]).slice(0, 365).map((it, i)=>{
        const recent = i < 60;
        const cap = (v, n)=>String(v==null?'':v).slice(0,n);
        return {
          dateKey: it.dateKey,
          entryId: it.entryId,
          callsign: it.callsign,
          tags: cap(it.tags, 1000),
          body: cap(it.body || it.userBody, recent ? 12000 : 2500),
          bodyRich: recent ? cap(it.bodyRich, 18000) : '',
          userBody: cap(it.userBody || it.body, recent ? 12000 : 2500),
          userBodyRich: recent ? cap(it.userBodyRich || it.bodyRich, 18000) : '',
          adminReply: cap(it.adminReply, recent ? 10000 : 2000),
          adminReplyRich: recent ? cap(it.adminReplyRich, 14000) : '',
          adminReplyAt: it.adminReplyAt,
          createdAt: it.createdAt,
          updatedAt: it.updatedAt
        };
      });
    }
    function saveCache_(){
	      try{ localStorage.setItem(LS_KEY, JSON.stringify({ v:3, savedAt: Date.now(), items: cachePack_(state.items) })); }catch(_e){}
	    }
	    function loadCache_(){
	      try{
	        const raw = localStorage.getItem(LS_KEY);
	        if(!raw) return;
	        const obj = JSON.parse(raw);
	        if(!obj || !Array.isArray(obj.items)) return;
	        state.items = mergeByDateKey_(state.items, obj.items);
	      }catch(_e){}
	    }


    const LS_DRAFT_KEY = 'slb_diary_draft_v1_' + String(role.callsign||'').trim().toUpperCase();
    function draftKey_(dk){ return LS_DRAFT_KEY + '_' + String(dk||'').trim(); }
    function getEditorHtmlRaw_(){ try{ return String(editor ? (editor.innerHTML||'') : ''); }catch(_e){ return ''; } }
    function getEditorHtml_(){
      try{ return String(((rich && rich.getHtml) ? rich.getHtml() : getEditorHtmlRaw_()) || ''); }catch(_e){ return getEditorHtmlRaw_(); }
    }
    function getEditorText_(){
      try{ return String(editor ? (editor.innerText||editor.textContent||'') : ((rich && rich.getText) ? rich.getText() : '')).trim(); }catch(_e){ return ''; }
    }
    function saveDraftForDate_(dk){
      try{
        dk = String(dk||'').trim();
        if(!dk) return;
        const html = getEditorHtmlRaw_();
        const plain = getEditorText_();
        const tags = String(tagsEl && tagsEl.value || '').trim();
        if(!html && !plain && !tags){
          localStorage.removeItem(draftKey_(dk));
          return;
        }
        localStorage.setItem(draftKey_(dk), JSON.stringify({ dateKey:dk, html:html, plain:plain, tags:tags, savedAt:Date.now() }));
      }catch(_e){}
    }
    function saveDraftNow_(){
      const dk = String((state && state.loadedDateKey) || (dateEl && dateEl.value) || '').trim();
      saveDraftForDate_(dk);
    }
    let _draftSaveTimer = null;
    function scheduleDraftSave_(){
      try{ if(_draftSaveTimer) clearTimeout(_draftSaveTimer); }catch(_e){}
      _draftSaveTimer = setTimeout(()=>{ saveDraftNow_(); }, 500);
    }
    function clearDraftForDate_(dk){ try{ localStorage.removeItem(draftKey_(dk)); }catch(_e){} }
    function loadDraftForDate_(dk){
      try{ const raw = localStorage.getItem(draftKey_(dk)); if(!raw) return null; const obj = JSON.parse(raw); return obj && typeof obj === 'object' ? obj : null; }catch(_e){ return null; }
    }
    try{ window.addEventListener('pagehide', ()=>saveDraftNow_()); }catch(_e){}
    try{ document.addEventListener('visibilitychange', ()=>{ if(document.hidden) saveDraftNow_(); }); }catch(_e){}
    // ===== Diary Read (self) =====
    const drListEl = $('slbDiaryReadList');
    const drMetaEl = $('slbDiaryReadMeta');
    const drBodyEl = $('slbDiaryReadBody');
	    const drSearchEl = $('slbDiaryReadSearch');
	    const drRefreshBtn = $('slbDiaryReadRefreshBtn');
	    const drEditBtn = $('slbDiaryReadEditBtn');
	    const drDeleteBtn = $('slbDiaryReadDeleteBtn');
    const drEmailBtn = $('slbDiaryReadEmailBtn');
    let drSelected = '';
	    let drCurrentItem = null;
	    let drFetchToken = 0;

	    function setReadBtns_(on){
	      const ok = !!on;
	      if(drEmailBtn) drEmailBtn.disabled = !ok;
	      if(drRefreshBtn) drRefreshBtn.disabled = !ok;
	      if(drEditBtn) drEditBtn.disabled = !ok;
	      if(drDeleteBtn) drDeleteBtn.disabled = !ok;
	    }

    function diaryReadSplitHtml_(it){
      const userHtml = itemUserHtml_(it);
      const replyHtml = itemAdminReplyHtml_(it);
      return `
        <div class="slbDiaryReadSplit" style="display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:12px;align-items:stretch;">
          <div class="slbDiaryReadPane slbDiaryReadPaneLeft" style="min-width:0;border:1px solid rgba(239,94,20,.16);border-radius:12px;background:var(--slb-panel,#fff);color:var(--slb-text,#0f1517);padding:10px;">
            <div class="slbDiaryReadPaneLabel" style="font-size:12px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#ef5e14;margin-bottom:8px;">Your entry</div>
            <div class="slbDiaryReadPaneBody" style="min-height:120px;max-height:420px;overflow:auto;padding:10px;border-radius:10px;background:var(--slb-panel-2,#faf8f6);color:var(--slb-text,#0f1517);">${userHtml || '<div class="muted">Empty.</div>'}</div>
          </div>
          <div class="slbDiaryReadPane slbDiaryReadPaneRight" style="min-width:0;border:1px solid rgba(239,94,20,.16);border-radius:12px;background:var(--slb-panel,#fff);color:var(--slb-text,#0f1517);padding:10px;">
            <div class="slbDiaryReadPaneLabel" style="font-size:12px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#ef5e14;margin-bottom:8px;">Si Juen reply</div>
            <div class="slbDiaryReadPaneBody" style="min-height:120px;max-height:420px;overflow:auto;padding:10px;border-radius:10px;background:var(--slb-panel-2,#faf8f6);color:var(--slb-text,#0f1517);">${replyHtml || '<div class="muted">No reply yet for this entry.</div>'}</div>
          </div>
        </div>
      `;
    }

    function relAgeShort_(iso){
      const t = Date.parse(String(iso||''));
      if(!t) return '';
      const ms = Date.now() - t;
      if(!isFinite(ms) || ms < 0) return '';
      const h = Math.floor(ms / 3600000);
      if(h < 1) return '<1h';
      if(h < 48) return String(h) + 'h';
      const d = Math.floor(ms / 86400000);
      if(d < 7) return String(d) + 'd';
      return '>7d';
    }

    function renderDiaryReadDates(){
      if(!drListEl) return;
	      const all = state.items || [];
	      const q = String(state.readQ||'').trim().toLowerCase();
	      const items = q ? all.filter(it=>{
	        const hay = (String(it.tags||'') + '\n' + String(it.body||'')).toLowerCase();
	        return hay.indexOf(q) >= 0;
	      }) : all;
      if(!items.length){
	        drListEl.innerHTML = q
	          ? '<div class="muted" style="padding:10px 12px;">No matches.</div>'
	          : '<div class="muted" style="padding:10px 12px;">No entries yet.</div>';
        return;
      }
      drListEl.innerHTML = items.map(it=>{
        const dkRaw = String(it.dateKey||'').trim();
        const dk = esc(dkRaw);
        const up = String(it.updatedAt||it.createdAt||'').trim();
        const age = esc(relAgeShort_(up));
        const active = (drSelected && drSelected === dkRaw);
        return `<div class="slbDiaryReadItem${active?' is-active':''}" data-dk="${dk}"><span class="dk">${dk}</span><span class="age">${age}</span></div>`;
      }).join('') + ((!q && state.hasMore) ? '<button class="btn soft mini" type="button" data-diary-load-older="1" style="margin:10px 12px;">Load older entries</button>' : '');
      try{
        drListEl.querySelectorAll('[data-dk]').forEach(row=>{
          row.addEventListener('click', ()=>{
            const dk = String(row.getAttribute('data-dk')||'').trim();
	            if(dk){
	              try{ fold.open('read'); fold.close('write'); }catch(_e){}
	              openDiaryRead_(dk);
	            }
          });
        });
        const more = drListEl.querySelector('[data-diary-load-older]');
        if(more) more.addEventListener('click', ()=>loadOlder_().catch(e=>setErr(e && (e.message||String(e)) || 'Failed to load older entries.')));
      }catch(_e){}
    }

	    function renderDiaryReadRight_(it){
      if(!drMetaEl || !drBodyEl) return;
      const t = fmtTimeToronto(it.updatedAt||it.createdAt);
      drMetaEl.innerHTML = 'Date: <b>'+esc(normDateKey(it.dateKey||it.date||it.dk||drSelected)||drSelected)+'</b> · Updated: <b>'+esc(t||'')+'</b>';
      const tagsRaw = String((it.tags!=null && it.tags!==undefined) ? it.tags : '').trim();
      const tagsHtml = tagsRaw ? esc(tagsRaw) : '<span class="muted">(no tags)</span>';
      drBodyEl.innerHTML = diaryReadSplitHtml_(it) + '<div class="slbDiaryReadSep"></div>' + '<div class="slbDiaryReadTags">'+tagsHtml+'</div>';
    }

    async function openDiaryRead_(dk){
      if(!drMetaEl || !drBodyEl) return;
      drSelected = String(dk||'').trim();
	      drCurrentItem = null;
	      setReadBtns_(false);
	      const token = ++drFetchToken;
      renderDiaryReadDates();
	      const cached = findItemByDate_(drSelected);
	    const cachedHasRich = !!(cached && String(cached.bodyRich||'').trim());
	    if(cached && cachedHasRich){
	      drCurrentItem = cached;
	      renderDiaryReadRight_(cached);
	      setReadBtns_(true);
	    } else {
	      // Avoid the plain→rich "jump": show nothing until rich loads.
	      setReadBtns_(false);
	      drMetaEl.textContent = 'Loading...';
	      drBodyEl.innerHTML = '';
	    }
      try{
        const res = await rpc('diaryGet', { dateKey: drSelected });
	        if(token !== drFetchToken) return;
        const out = res && (res.result || res);
        const it = out && out.item ? out.item : null;
        if(!it){
          drMetaEl.textContent = 'No entry found.';
	          drBodyEl.innerHTML = '';
	          drCurrentItem = null;
	          setReadBtns_(false);
          return;
        }
	        drCurrentItem = it;
	        renderDiaryReadRight_(it);
	        setReadBtns_(true);
	        // merge the latest copy into local cache
	        state.items = mergeByDateKey_(state.items, [it]);
	        saveCache_();
	        renderDiaryReadDates();
      }catch(e){
	        if(token !== drFetchToken) return;
        drMetaEl.textContent = 'Failed to load.';
        drBodyEl.innerHTML = '<div class="err">'+esc(e && (e.message||String(e)))+'</div>';
	        setReadBtns_(!!cached);
      }
    }


    function findItemByDate_(dk){
      dk = String(dk||'').trim();
      return (state.items||[]).find(it => String(it.dateKey||'').trim() === dk) || null;
    }
    function clearEditorForNew_(dk){
      try{ tagsEl.value = ''; }catch(_e){}
      try{ rich.setHtml(''); }catch(_e2){}
      try{ updateWordCounter_(); }catch(_e3){}
      state.loadedDateKey = String(dk||'').trim();
      state.loadedHadExisting = false;
      try{
        const draft = loadDraftForDate_(state.loadedDateKey);
        if(draft){
          const dHtml = sanitizeRichHtml(String(draft.html||''));
          const dTags = String(draft.tags||'');
          if(dHtml){ try{ rich.setHtml(dHtml); }catch(_e4a){} }
          if(tagsEl) tagsEl.value = dTags;
          try{ updateWordCounter_(); }catch(_e4b){}
        }
      }catch(_e4c){}
      try{ syncPrevReplyForDate_(dk, null); }catch(_e4){}
      setOk('');
      setErr('');
    }
    async function ensureDateLoaded_(dk){
      dk = String(dk||'').trim();
      if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dk)) return;
      await openEntry(dk);
    }
    function kickstartInitialWriteLoad_(){
      if(state._initialWriteHydrated) return;
      state._initialWriteHydrated = true;
      const dk = String(dateEl && dateEl.value || '').trim();
      if(!dk) return;
      ensureDateLoaded_(dk).catch(e=>setErr(e && (e.message||String(e)) || 'Failed to load current entry.'));
    }

    function renderList(){
      const box = $('slbDiaryList');
      const items = state.items || [];
	      if(box){
	        if(!items.length){
	          box.innerHTML = '<div class="muted">No entries yet.</div>';
	        } else {
	          const rows = items.map(it => {
	            const dk = esc(it.dateKey||'');
	            const tags = esc(it.tags||'');
	            const t = fmtTimeToronto(it.updatedAt||it.createdAt);
	            const snip = esc(itemPreviewPlain_(it).slice(0, 220));
	            return `
	              <tr data-open="${dk}" style="cursor:pointer;">
	                <td style="width:130px;">
	                  <div style="font-weight:800;">${dk}</div>
	                  <div class="muted" style="font-size:12px;margin-top:2px;">${esc(t||'')}</div>
	                </td>
	                <td style="width:200px;" class="muted">${tags}</td>
	                <td class="muted" style="white-space:pre-wrap;">${snip}</td>
	              </tr>
	            `;
	          }).join('');
	          box.innerHTML = `
	            <div class="slbTableWrap">
	              <table style="width:100%;border-collapse:separate;border-spacing:0;">
	              <tbody>
	                ${rows}
	              </tbody>
	              </table>
	            </div>
	            <div class="muted" style="margin-top:6px;font-size:12px;">Tip: click a row to open.</div>
	          `;
	          try{
	            box.querySelectorAll('tr[data-open]').forEach(tr=>{
	              tr.addEventListener('click', ()=>{
	                const dk = String(tr.getAttribute('data-open')||'').trim();
	                if(dk) openEntry(dk).catch(e=>setErr(e.message||String(e)));
	              });
	            });
	          }catch(_e){}
	        }
	      }
	      try{
        const moreBtn = $('slbDiaryMore');
        if(moreBtn) moreBtn.classList.toggle('hidden', !state.hasMore);
      }catch(_eMore){}
      try{ renderDiaryReadDates(); }catch(_e2){}
    }

    async function loadList(force){
      const now = Date.now();
      if(state._syncing) return;
      if(!force && state._lastSyncAt && (now - state._lastSyncAt) < 60*1000) return;
      state._syncing = true;
      try{
        const res = await rpc('diaryList', { limit: 180, includeRich: false });
        const out = res && (res.result || res);
        const got = (out && out.items) ? out.items : [];
        if(got.length) state.items = mergeByDateKey_(state.items, got);
        state.hasMore = !!(out && out.hasMore);
        state.nextBeforeDateKey = String(out && out.nextBeforeDateKey || '').trim();
        saveCache_();
        renderList();
        state._lastSyncAt = Date.now();
      }catch(_e){
        try{ setErr(_e && (_e.message||String(_e))); }catch(_e2){}
      }finally{
        state._syncing = false;
      }
    }

    async function loadOlder_(){
      if(state._syncing || !state.hasMore || !state.nextBeforeDateKey) return;
      state._syncing = true;
      try{
        const res = await rpc('diaryList', { limit:180, includeRich:false, beforeDateKey:state.nextBeforeDateKey });
        const out = res && (res.result || res);
        const got = (out && out.items) ? out.items : [];
        if(got.length) state.items = mergeByDateKey_(state.items, got);
        state.hasMore = !!(out && out.hasMore);
        state.nextBeforeDateKey = String(out && out.nextBeforeDateKey || '').trim();
        saveCache_();
        renderList();
      }finally{
        state._syncing = false;
      }
    }

    async function openEntry(dateKey){
      setErr('');
      setOk('');
      const dk = String(dateKey||'').trim();
      if(!dk) return;
      const token = ++state._writeFetchToken;
      try{ if(editor) editor.setAttribute('aria-busy','true'); }catch(_e){}
      try{
        const res = await rpc('diaryGet', { dateKey: dk });
        if(token !== state._writeFetchToken) return;
        const out = res && (res.result || res);
        const it = out && out.item ? out.item : null;
        if(!it){
          clearEditorForNew_(dk);
          setOk('New entry.');
          return;
        }
        try{ dateEl.value = normDateKey(it.dateKey||dk) || normDateKey(dk) || torontoDateKey(new Date()); }catch(_e){}
        const serverHtml = itemUserHtml_(it);
        const draft = loadDraftForDate_(dk);
        const serverT = Date.parse(String(it.userUpdatedAt||it.updatedAt||it.createdAt||'')) || 0;
        const draftT = Number(draft && draft.savedAt || 0) || 0;
        const draftHasContent = !!(draft && (String(draft.html||'').trim() || String(draft.plain||'').trim() || String(draft.tags||'').trim()));
        const useDraft = draftHasContent && (!serverT || draftT > serverT + 1000);
        if(useDraft){
          const dHtml = sanitizeRichHtml(String(draft.html||''));
          try{ tagsEl.value = String(draft.tags||it.tags||''); }catch(_e2){}
          rich.setHtml(dHtml || serverHtml || '');
          setOk('Restored your newer unsent local draft.');
        }else{
          try{ tagsEl.value = String(it.tags||''); }catch(_e2){}
          rich.setHtml(serverHtml||'');
          setOk('Loaded.');
        }
        updateWordCounter_();
        try{ syncPrevReplyForDate_(dk, it); }catch(_e4){}
        state.loadedDateKey = dk;
        state.loadedHadExisting = true;
        state.items = mergeByDateKey_(state.items, [it]);
        saveCache_();
        renderList();
      }finally{
        if(token === state._writeFetchToken){ try{ if(editor) editor.removeAttribute('aria-busy'); }catch(_e){} }
      }
    }

    function diaryTransportUncertain_(err){
      const m=String((err&&(err.message||err))||'').toLowerCase();
      return /secure response poll|secure backend timeout|blocked|network|timed out|failed to load|load error|transport/.test(m);
    }
    function diaryPlainNorm_(v){ return String(v==null?'':v).replace(/\r\n/g,'\n').replace(/\r/g,'\n').replace(/\s+/g,' ').trim(); }
    function diaryPreferSecure_(){ try{ if(window.SLBPostBridge&&typeof window.SLBPostBridge.disableCompatibility==='function') window.SLBPostBridge.disableCompatibility(); }catch(_e){} }

    function saveLocal(){
      setErr('');
      setOk('');
      try{
        const dk = String(dateEl.value||'').trim();
        if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dk)){
          setErr('Invalid date.');
          return false;
        }
        saveDraftNow_();
        setOk('Saved locally on this device. Use Submit when you are ready to send it.');
        return true;
      }catch(e){
        setErr((e && (e.message||String(e))) || 'Local save failed.');
        return false;
      }
    }

    function diaryClientSubmitId_(dk){
      try{ if(window.crypto && crypto.randomUUID) return 'DIARY_' + dk + '_' + crypto.randomUUID(); }catch(_e){}
      return 'DIARY_' + dk + '_' + Date.now() + '_' + Math.random().toString(36).slice(2,10);
    }
    function acceptSavedDiary_(dk, item){
      if(item){
        state.items = mergeByDateKey_(state.items, [item]);
        try{ tagsEl.value = String(item.tags||tagsEl.value||''); }catch(_e){}
        state.loadedHadExisting = true;
        state.loadedDateKey = dk;
        saveCache_();
        renderList();
      }
      clearDraftForDate_(dk);
    }

    async function submit(){
      setErr('');
      setOk('');
      const submitBtn = $('slbDiarySubmit');
      let payload = null;
      let clientSubmitId = '';
      if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Submitting...'; }
      try{
        const dk = String(dateEl.value||'').trim();
        if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dk)){
          setErr('Invalid date.');
          return;
        }
        let tags = String(tagsEl.value||'').trim();
        let bodyRich = rich.getHtml();
        let body = rich.getText();

        // Only preflight when this date was never loaded. A checked-new date has
        // loadedDateKey===dk and does not need another read before submit.
        if(state.loadedDateKey !== dk){
          try{
            const res0 = await rpc('diaryGet', { dateKey: dk });
            const out0 = res0 && (res0.result || res0);
            if(out0 && out0.item){
              const ex = out0.item;
              const exHtml = sanitizeRichHtml(itemUserHtml_(ex));
              const newHtml = sanitizeRichHtml(bodyRich);
              const mergedHtml = (exHtml && newHtml) ? (exHtml + '<br><br>' + newHtml) : (exHtml || newHtml);
              bodyRich = mergedHtml;
              body = htmlToPlain(mergedHtml);
              tags = mergeTags(String(ex.tags||''), tags);
            }
          }catch(_e){}
        }
        if(!body && !bodyRich){ setErr('Body is empty.'); return; }

        clientSubmitId = diaryClientSubmitId_(dk);
        payload = {
          dateKey:dk, tags:tags, body:body, bodyRich:bodyRich,
          userBody:body, userBodyRich:bodyRich, lastActor:'user',
          notifySiJuen:true, clientSubmitId:clientSubmitId
        };
        const savedRes = await rpc('diaryUpsert', payload, { outbox: { module:'diary', key:obKeyDiary_(payload) } });
        const savedOut = savedRes && (savedRes.result || savedRes.data || savedRes) || {};
        acceptSavedDiary_(dk, savedOut.item || null);
        const sp = Number(savedOut.spAwarded||0)>0 ? ' SP +1 earned for a 200+ word diary.' : '';
        if(savedOut.emailSent === false){
          setOk('Diary saved to SLB.' + sp);
          setErr('Email notification to Jee Si Juen could not be confirmed. Your diary is safe; use >> Si Juen in Read to retry the email only.');
        }else{
          setOk('Submitted to SLB and emailed to Jee Si Juen.' + sp);
        }
      }catch(e){
        if(payload && diaryTransportUncertain_(e)){
          try{
            diaryPreferSecure_();
            const verifyRes = await rpc('diaryGet', { dateKey:payload.dateKey }, { timeoutMs:90000, noGlobalRetry:true, __slbNoGlobalRetry:true });
            const verifyOut = verifyRes && (verifyRes.result || verifyRes);
            const verifyItem = verifyOut && verifyOut.item;
            const serverPlain = verifyItem ? String(verifyItem.userBody||verifyItem.body||htmlToPlain(verifyItem.userBodyRich||verifyItem.bodyRich||'')) : '';
            if(verifyItem && diaryPlainNorm_(serverPlain)===diaryPlainNorm_(payload.body)){
              let emailOk = true;
              try{
                await rpc('diaryEmailToSiJuen', { dateKey:payload.dateKey, clientSubmitId:clientSubmitId }, { timeoutMs:90000, noGlobalRetry:true, __slbNoGlobalRetry:true });
              }catch(_emailErr){ emailOk = false; }
              acceptSavedDiary_(payload.dateKey, verifyItem);
              setErr(emailOk ? '' : 'Diary was verified as saved, but the email notification could not be confirmed. Use >> Si Juen in Read to retry the email only.');
              setOk(emailOk ? 'Submitted and verified. The browser lost only the first confirmation.' : 'Diary saved and verified.');
              return;
            }
          }catch(_verifyErr){}
        }
        setErr(((e && (e.message||String(e))) || 'Submit failed.') + ' Your local diary backup is still safe. Please retry once; SLB will verify the same date without creating a duplicate.');
      }finally{
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Submit'; }
      }
    }

	    async function refreshRead_(){
	      if(!drSelected) return;
	      await openDiaryRead_(drSelected);
	    }

	    async function emailToSiJuenFromRead_(){
	      if(!drSelected) return;
	      if(drEmailBtn){
	        drEmailBtn.disabled = true;
	        drEmailBtn.textContent = 'Sending...';
	      }
	      try{ if(window.SLB_APP && SLB_APP.toast) SLB_APP.toast('ok','Sending to Si Juen...'); }catch(_e){}
	      try{
	        await rpc('diaryEmailToSiJuen', { dateKey: drSelected });
	        try{ if(window.SLB_APP && SLB_APP.toast) SLB_APP.toast('ok','Sent to Si Juen.'); }catch(_e2){}
	      }finally{
	        if(drEmailBtn){
	          drEmailBtn.textContent = '>> Si Juen';
	          drEmailBtn.disabled = !drSelected;
	        }
	      }
	    }

	    async function editFromRead_(){
	      if(!drSelected || !drCurrentItem) return;
	      const it = drCurrentItem;
	      try{ dateEl.value = normDateKey(it.dateKey||drSelected) || normDateKey(drSelected) || torontoDateKey(new Date()); }catch(_e){}
	      try{ tagsEl.value = String(it.tags||''); }catch(_e){}
	      const htmlRaw = String((it.bodyRich!=null && it.bodyRich!==undefined) ? it.bodyRich : '').trim();
	      const bodyRaw = String((it.body!=null && it.body!==undefined) ? it.body : '').trim();
	      const html = sanitizeRichHtml(htmlRaw ? toHtmlMaybe(htmlRaw) : toHtmlMaybe(bodyRaw));
	      try{ rich.setHtml(html||'');
      try{ updateWordCounter_(); }catch(_e3){} }catch(_e){}
	      state.loadedDateKey = String(normDateKey(it.dateKey||drSelected) || drSelected);
	      state.loadedHadExisting = true;
	      setOk('Loaded for editing.');
	      try{ fold.open('write'); fold.close('read'); }catch(_e){}
	    }

	    async function deleteFromRead_(){
	      if(!drSelected) return;
	      if(!confirm('Delete this entry permanently?')) return;
	      setErr('');
	      setOk('');
	      const oldText = drDeleteBtn ? (drDeleteBtn.textContent||'Delete') : 'Delete';
	      if(drDeleteBtn){ drDeleteBtn.disabled = true; drDeleteBtn.textContent = 'Deleting...'; }
	      try{
	        await rpc('diaryDelete', { dateKey: drSelected });
	        state.items = (state.items||[]).filter(it=>String(it.dateKey||'') !== String(drSelected));
	        saveCache_();
	        drSelected = '';
	        drCurrentItem = null;
	        setReadBtns_();
	        renderList();
	        if(drMetaEl) drMetaEl.textContent = 'Select a date to read.';
	        if(drBodyEl) drBodyEl.innerHTML = '<div class="slbSkelBox" style="padding:10px 12px;"><div class="slbSkelLine"></div><div class="slbSkelLine"></div><div class="slbSkelLine"></div><div class="slbSkelLine"></div></div>';
	        setOk('Deleted.');
	      }catch(e){
	        setErr((e && (e.message||String(e))) || 'Delete failed.');
	      }finally{
	        if(drDeleteBtn){ drDeleteBtn.textContent = oldText || 'Delete'; }
	        setReadBtns_();
	      }
	    }

	    function parseCsvRows_(text){
	      const rows = [];
	      let row = [];
	      let field = '';
	      let inQ = false;
	      for(let i=0;i<text.length;i++){
	        const c = text[i];
	        if(inQ){
	          if(c === '"'){
	            if(text[i+1] === '"'){ field += '"'; i++; }
	            else { inQ = false; }
	          } else {
	            field += c;
	          }
	          continue;
	        }
	        if(c === '"'){ inQ = true; continue; }
	        if(c === ','){ row.push(field); field = ''; continue; }
	        if(c === '\r'){ continue; }
	        if(c === '\n'){
	          row.push(field);
	          if(row.some(v => String(v||'').length)) rows.push(row);
	          row = [];
	          field = '';
	          continue;
	        }
	        field += c;
	      }
	      row.push(field);
	      if(row.some(v => String(v||'').length)) rows.push(row);
	      return rows;
	    }

	    async function importCsvFile_(file){
	      if(!file) return;
	      setErr('');
	      setOk('');
	      const text = String(await file.text()||'');
	      const rows = parseCsvRows_(text);
	      if(rows.length < 2){
	        setErr('CSV is empty.');
	        return;
	      }
	      const header = rows[0].map(h=>String(h||'').replace(/^\uFEFF/, '').trim());
	      const lc = header.map(h=>h.toLowerCase());
	      const idx = (name)=> lc.indexOf(String(name).toLowerCase());
	      const iDateKey = idx('dateKey');
	      const iTags = idx('tags');
	      const iBody = idx('body');
	      const iBodyRich = idx('bodyRich');
	      if(iDateKey < 0){
	        setErr('CSV missing dateKey column.');
	        return;
	      }
	      const total = rows.length - 1;
	      if(!confirm(`Import ${total} entries? Existing dates will be overwritten.`)) return;
	      let ok = 0;
	      let fail = 0;
	      for(let r=1;r<rows.length;r++){
	        const row = rows[r];
	        const dk = normDateKey(row[iDateKey]);
	        if(!dk) continue;
	        const tags = String(iTags>=0 ? (row[iTags]||'') : '');
	        const body = String(iBody>=0 ? (row[iBody]||'') : '');
	        const bodyRich = String(iBodyRich>=0 ? (row[iBodyRich]||'') : '');
	        try{
	          var _obDiary2 = { dateKey: dk, tags: tags, body: body, bodyRich: bodyRich };
	          await rpc('diaryUpsert', _obDiary2, { outbox: { module: 'diary', key: obKeyDiary_(_obDiary2) } });
	          ok++;
	        } catch(_e){
	          fail++;
	        }
	        if((ok+fail) % 10 === 0){
	          setOk(`Importing... ${ok+fail}/${total}`);
	        }
	        await new Promise(res=>setTimeout(res, 60));
	      }
	      // refresh local cache once
	      await loadList(true).catch(()=>{});
	      setOk(`Import done: ${ok} ok${fail?`, ${fail} failed`:''}.`);
      return { ok:ok, fail:fail, total:total };
	    }

    // bind
    const saveBtn = $('slbDiarySave');
    const submitBtn = $('slbDiarySubmit');
    if(saveBtn) saveBtn.addEventListener('click', ()=>saveLocal());
    if(submitBtn) submitBtn.addEventListener('click', ()=>submit().catch(e=>setErr(e.message||String(e))));

    if(dateEl){
      dateEl.addEventListener('change', ()=>{
        const oldDk = String(state.loadedDateKey||'').trim();
        if(oldDk){ try{ saveDraftForDate_(oldDk); }catch(_e){} }
        const dk = String(dateEl.value||'').trim();
        ensureDateLoaded_(dk).catch(e=>setErr(e.message||String(e)));
      });
    }

	    // READ: filter + actions
	    if(drSearchEl){
	      drSearchEl.addEventListener('input', ()=>{
	        state.readQ = String(drSearchEl.value||'');
	        renderDiaryReadDates();
	      });
	      drSearchEl.addEventListener('keydown', (ev)=>{
	        if(ev && ev.key === 'Escape'){
	          drSearchEl.value = '';
	          state.readQ = '';
	          renderDiaryReadDates();
	        }
	      });
	    }
	    if(drEmailBtn) drEmailBtn.addEventListener('click', ()=>emailToSiJuenFromRead_().catch(e=>setErr(e.message||String(e))));
	    if(drRefreshBtn) drRefreshBtn.addEventListener('click', ()=>refreshRead_().catch(e=>setErr(e.message||String(e))));
	    if(drEditBtn) drEditBtn.addEventListener('click', ()=>editFromRead_().catch(e=>setErr(e.message||String(e))));
	    if(drDeleteBtn) drDeleteBtn.addEventListener('click', ()=>deleteFromRead_().catch(e=>setErr(e.message||String(e))));

	    // Fold open hooks (keep folds default-collapsed)
	    const writeOpenBtn = panel.querySelector('button[data-fold="write"]');
	    if(writeOpenBtn){
	      writeOpenBtn.addEventListener('click', ()=>{
	        setTimeout(()=>{
	          if(!fold.isOpen('write')) return;
	          const dk = String(dateEl && dateEl.value ? dateEl.value : torontoDateKey(new Date())).trim();
	          ensureDateLoaded_(dk).catch(e=>setErr(e.message||String(e)));
	        }, 0);
	      });
	    }
	    const readOpenBtn = panel.querySelector('button[data-fold="read"]');
	    if(readOpenBtn){
	      readOpenBtn.addEventListener('click', ()=>{
	        setTimeout(()=>{
	          if(!fold.isOpen('read')) return;
	          renderDiaryReadDates();
          loadList(false).catch(()=>{});
	        }, 0);
	      });
	    }

	    // Import CSV
	    const impBtn = $('slbDiaryImportCsv');
	    const impFile = $('slbDiaryImportCsvFile');
	    if(impBtn && impFile){
	      impBtn.addEventListener('click', ()=>{ try{ impFile.click(); }catch(_e){} });
	      impFile.addEventListener('change', ()=>{
	        const f = impFile.files && impFile.files[0];
	        if(f) importCsvFile_(f).catch(e=>setErr(e.message||String(e)));
	        try{ impFile.value = ''; }catch(_e){}
	      });
	    }

    const moreBtn = $('slbDiaryMore');
    if(moreBtn) moreBtn.addEventListener('click', ()=>loadOlder_().catch(e=>setErr(e && (e.message||String(e)) || 'Failed to load older entries.')));

    const listBox = $('slbDiaryList');
    if(listBox){
      listBox.addEventListener('click', (ev)=>{
        const b = ev.target.closest('button[data-open]');
        if(!b) return;
        const dk = String(b.getAttribute('data-open')||'').trim();
        openEntry(dk).catch(e=>setErr(e.message||String(e)));
      });
    }

    const searchEl = $('slbDiarySearch');
    if(searchEl){
      let t=null;
      searchEl.addEventListener('input', ()=>{
        clearTimeout(t);
        t = setTimeout(()=>loadList(true).catch(e=>setErr(e.message||String(e))), 300);
      });
    }

    // Diary CSV export is exposed for Settings → Backup.
    async function exportCsv_(){
      setErr(''); setOk('');
      let part = 1;
      let before = '';
      while(true){
        const res = await rpc('diaryExportCsv', { partNumber: part, beforeDateKey: before, maxEntries: 200 });
        const out = res && (res.result || res);
        if(out && out.csvText) downloadText(out.fileName || ('Diary_part'+part+'.csv'), out.csvText);
        if(!(out && out.hasMore)) break;
        before = String(out.nextBeforeDateKey||'');
        part++;
        if(!confirm('More parts remain. Download next part?')) break;
      }
      return true;
    }
    const expCsv = $('slbDiaryExportCsv');
    if(expCsv) expCsv.addEventListener('click', ()=>exportCsv_().catch(e=>setErr(e.message||String(e))));

    const expZip = $('slbDiaryExportZip');
    if(expZip) expZip.addEventListener('click', async ()=>{
      setErr(''); setOk('');
      let part = 1;
      let before = '';
      while(true){
        const res = await rpc('diaryExportZip', { partNumber: part, beforeDateKey: before, maxEntries: 80 });
        const out = res && (res.result || res);
        if(out && out.zipBase64) downloadBase64(out.fileName || ('Diary_part'+part+'.zip'), out.zipBase64, 'application/zip');
        if(!(out && out.hasMore)) break;
        before = String(out.nextBeforeDateKey||'');
        part++;
        if(!confirm('More parts remain. Download next part?')) break;
      }
    });

    // Public Diary backup/latest-reply tools used by My Cabin.
    window.SLB_DIARY = window.SLB_DIARY || {};
    window.SLB_DIARY.importCsvFile = function(file){ return importCsvFile_(file); };
    window.SLB_DIARY.exportCsv = function(){ return exportCsv_(); };
    window.SLB_DIARY.getLatestReply = async function(){
      try{ await loadList(false); }catch(_e){}
      let src = (state.items||[]).slice().sort((a,b)=>String(b.dateKey||'').localeCompare(String(a.dateKey||''))).find(it=>itemAdminReplyHtml_(it));
      if(!src) return null;
      if(!String(src.adminReplyRich||'').trim()){
        try{
          const res = await rpc('diaryGet', { dateKey:String(src.dateKey||'') });
          const out = res && (res.result || res);
          if(out && out.item){ src = out.item; state.items = mergeByDateKey_(state.items,[src]); saveCache_(); }
        }catch(_e2){}
      }
      return {
        dateKey:String(src.dateKey||''),
        updatedAt:String(src.adminReplyAt||src.updatedAt||src.createdAt||''),
        html:sanitizeRichHtml(itemAdminReplyHtml_(src))
      };
    };

    // initial load (snappy)
    loadCache_();
    try{ renderList(); }catch(_e){}
    try{ setReadBtns_(); }catch(_e){}
    setTimeout(()=>{ try{ kickstartInitialWriteLoad_(); }catch(_e){} }, 20);
    // Phase C: restore last opened Read entry
    try{
      const lastDk = String(lsGet_(LS_LAST_DK)||'').trim();
      if(lastDk){
        setTimeout(()=>{
          try{ fold.open('read'); fold.close('write'); }catch(_e){}
          openDiaryRead_(lastDk).catch(()=>{});
        }, 50);
      }
    }catch(_e){}
    // History is lazy-loaded when Read is opened. Keep startup focused on today's entry.
    // Sleep the refresh timer in hidden tabs and restart it only if Read is still open.
    if(!panel.__slbDiaryReadVisibilityBound){
      panel.__slbDiaryReadVisibilityBound = true;
      document.addEventListener('visibilitychange', ()=>{
        try{
          if(document.hidden){ stopReadRefreshTimer_(); return; }
          if(fold && fold.isOpen && fold.isOpen('read')){
            loadList(false).catch(()=>{});
            startReadRefreshTimer_();
          }
        }catch(_e){}
      });
    }
  }

  // ===== UI (admin diary) =====
  function mountAdmin(){
    const panel = $('slbDiaryAdminPanel');
    if(!panel || panel.__slbDiaryAdmMounted) return;
    panel.__slbDiaryAdmMounted = true;

    const role = getRole();
    if(!role.callsign){
      panel.innerHTML = '<div class="err">Please login first.</div>';
      return;
    }
    if(!role.isAdminOrMod){
      panel.innerHTML = '<div class="err">Forbidden.</div>';
      return;
    }

    panel.innerHTML = `
      <div class="row" style="gap:10px;flex-wrap:wrap;align-items:flex-end;">
        <div style="min-width:200px;">
          <label>Target callsign</label>
          <select id="slbDiaryAdmCall"></select>
        </div>
        <div style="display:flex;gap:8px;flex-wrap:wrap;">
          <button class="btn soft mini" id="slbDiaryAdmLoad" type="button">Load</button>
        </div>
      </div>
      <div class="hr" style="margin:12px 0;"></div>
      <div id="slbDiaryAdmInner"></div>
    `;
    elViewer = panel;


    // Populate callsign dropdown
    async function loadCallsignDropdown(){
      const sel = $('slbDiaryAdmCall');
      if(!sel) return;
      sel.innerHTML = '<option value="">Select callsign...</option>';
      try{
        const res = await rpc('adminDiscipleList', { includeOut:false, limit: 10000 });
        const out = res && (res.result || res);
        const arr = (out && out.in) ? out.in : [];
        const calls = arr.map(x=>String(x.callsign||x.callSign||x.cs||'').trim().toUpperCase()).filter(Boolean);
        calls.sort();
        calls.forEach(cs=>{
          const opt = document.createElement('option');
          opt.value = cs;
          opt.textContent = cs;
          sel.appendChild(opt);
        });
      }catch(e){
        // keep empty select
      }
    }

    const inner = $('slbDiaryAdmInner');
    if(!inner) return;
    inner.innerHTML = buildDiaryHtml({ title: 'Diary (Admin)', mode: 'admin' });
loadCallsignDropdown().catch(()=>{});


    // Re-wire IDs inside inner (duplicate IDs exist in DOM if main diary also loaded)
    // To keep minimal, we scope all queries to 'inner' for admin.
    function q(sel){ return inner.querySelector(sel); }
    function show(el,on){ if(!el) return; el.classList.toggle('hidden', !on); }
    function setErr(msg){
      const e = q('#slbDiaryErr');
      const o = q('#slbDiaryOk');
      if(o) show(o,false);
      if(e){ e.textContent = String(msg||''); show(e, !!msg); }
    }
    function setOk(msg){
      const e = q('#slbDiaryErr');
      const o = q('#slbDiaryOk');
      if(e) show(e,false);
      if(o){ o.textContent = String(msg||''); show(o, !!msg); }
    }

    const dateEl = q('#slbDiaryDate');
    const tagsEl = q('#slbDiaryTags');
    const editor = q('#slbDiaryBodyRich');
    const toolbar = q('#slbDiaryWysToolbar');
    const colorEl = q('#slbDiaryWysColor');
    const sizeEl = q('#slbDiaryWysSize');
    const headingEl = q('#slbDiaryHeading');
    const hlEl = q('#slbDiaryWysHl');
    const rich = installRichEditor(toolbar, editor, { colorEl, hlEl, sizeEl, headingEl });

    
    // Word/char counter (soft cap for typing feedback)
    const wcEl = $('slbDiaryWordCounter');
    const WC_MAX_CHARS = 45000;
    function countWords_(txt){
      const t = String(txt||'').trim();
      if(!t) return 0;
      return t.split(/\s+/g).filter(Boolean).length;
    }
    function updateWordCounter_(){
  if(!wcEl) return;

  let text = '';
  try{
    text = (rich && rich.getText) ? rich.getText() : (editor ? editor.innerText : '');
  }catch(_e){
    text = (editor ? editor.innerText : '');
  }
  text = String(text||'');

  let richHtml = '';
  try{
    richHtml = (rich && rich.getHtml) ? rich.getHtml() : (editor ? editor.innerHTML : '');
  }catch(_e2){
    richHtml = (editor ? editor.innerHTML : '');
  }
  richHtml = String(richHtml||'');

  const plainChars = text.length;
  const richChars = richHtml.length;
  const left = Math.max(0, WC_MAX_CHARS - richChars);
  const over = Math.max(0, richChars - WC_MAX_CHARS);

  if(over > 0){
    wcEl.textContent = 'Rich ' + richChars + '/' + WC_MAX_CHARS + ' · OVER ' + over + ' · Text ' + plainChars;
  }else{
    wcEl.textContent = 'Rich ' + richChars + '/' + WC_MAX_CHARS + ' · ' + left + ' left · Text ' + plainChars;
  }
}
    if(editor){
      editor.addEventListener('input', ()=>{ updateWordCounter_(); scheduleDraftSave_(); });
      editor.addEventListener('keyup', ()=>updateWordCounter_());
      editor.addEventListener('blur', ()=>saveDraftNow_());
    }
    if(tagsEl){
      tagsEl.addEventListener('input', ()=>scheduleDraftSave_());
      tagsEl.addEventListener('blur', ()=>saveDraftNow_());
    }
    updateWordCounter_();

    // quote: use formatBlock=BLOCKQUOTE button

    if(toolbar){
      toolbar.addEventListener('click', (ev)=>{
        const b = ev.target.closest('button[data-wcmd]');
        if(!b) return;
        const cmd = String(b.getAttribute('data-wcmd')||'');
        const val = String(b.getAttribute('data-wval')||'');
        if(cmd === 'formatBlock' && val){
          try{ document.execCommand('formatBlock', false, val); }catch(_e){}
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
        }
      }, true);
    }

    const state = { 
      target:'', 
      items:[], 
      beforeDateKey:'', 
      hasMore:false,
      loadedDateKey:'',
      loadedHadExisting:false,
      _autoInitDone:false
    };

    function findItemByDate_(dk){
      dk = String(dk||'').trim();
      return (state.items||[]).find(it => String(it.dateKey||'').trim() === dk) || null;
    }
    function clearEditorForNew_(dk){
      try{ tagsEl.value = ''; }catch(_e){}
      try{ rich.setHtml(''); }catch(_e2){}
      try{ updateWordCounter_(); }catch(_e3){}
      state.loadedDateKey = String(dk||'').trim();
      state.loadedHadExisting = false;
      setOk('');
      setErr('');
    }
    async function ensureDateLoaded_(dk){
      dk = String(dk||'').trim();
      if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dk)) return;
      await openEntry(dk);
    }

    function renderList(){
      const box = q('#slbDiaryList');
      if(!box) return;
      const items = state.items || [];
      if(!items.length){
        box.innerHTML = '<div class="muted">No entries yet.</div>';
        return;
      }
      const rows = items.map(it => {
        const dk = esc(it.dateKey||'');
        const tags = esc(it.tags||'');
        const t = fmtTimeToronto(it.updatedAt||it.createdAt);
        const snip = esc(itemPreviewPlain_(it).slice(0, 220));
        return `
          <tr data-open="${dk}" style="cursor:pointer;">
            <td style="width:130px;">
              <div style="font-weight:800;">${dk}</div>
              <div class="muted" style="font-size:12px;margin-top:2px;">${esc(t||'')}</div>
            </td>
            <td style="width:200px;" class="muted">${tags}</td>
            <td class="muted" style="white-space:pre-wrap;">${snip}</td>
          </tr>
        `;
      }).join('');
      box.innerHTML = `
        <div class="slbTableWrap">
          <table style="width:100%;border-collapse:separate;border-spacing:0;">
          <tbody>
            ${rows}
          </tbody>
        </table>
        <div class="muted" style="margin-top:6px;font-size:12px;">Tip: click a row to open.</div>
      `;
      try{
        box.querySelectorAll('tr[data-open]').forEach(tr=>{
          tr.addEventListener('click', ()=>{
            const dk = String(tr.getAttribute('data-open')||'').trim();
            if(dk) openEntry(dk).catch(e=>setErr(e.message||String(e)));
          });
        });
      }catch(_e){}
      try{ renderDiaryReadDates(); }catch(_e2){}
    }

    async function loadList(reset){
      setErr(''); setOk('');
      const qText = String(q('#slbDiarySearch') ? q('#slbDiarySearch').value : '').trim();
      const targetAtStart = String(state.target||'').trim().toUpperCase();
      if(!targetAtStart){ setErr('Enter target callsign, then Load.'); return false; }
      if(reset){ state.items=[]; state.beforeDateKey=''; state.hasMore=false; }
      const payload = { callsign: targetAtStart, q: qText, limit: 120 };
      if(state.beforeDateKey) payload.beforeDateKey = state.beforeDateKey;
      let res;
      try{
        res = await rpc('diarySearch', payload, { latestKey:'diary:admin:list' });
      }catch(e){
        if(isStaleRequest_(e)) return false;
        throw e;
      }
      if(String(state.target||'').trim().toUpperCase() !== targetAtStart) return false;
      const out = res && (res.result || res);
      const items = (out && out.items) ? out.items : [];
      state.hasMore = !!(out && out.hasMore);
      state.beforeDateKey = (out && out.nextBeforeDateKey) ? String(out.nextBeforeDateKey||'') : '';
      state.items = mergeByDateKey_(state.items, items);
      renderList();
      show(q('#slbDiaryMore'), state.hasMore);
      if(reset && !state._autoInitDone){
        state._autoInitDone = true;
        try{ await ensureDateLoaded_(String(dateEl && dateEl.value || '').trim()); }catch(_e){}
      }
      return true;
    }

    async function openEntry(dateKey){
      setErr(''); setOk('');
      try{ if(window.SLB_APP && SLB_APP.toast) SLB_APP.toast('ok','Loading...'); }catch(_e){}
      const dk = String(dateKey||'').trim();
      const targetAtStart = String(state.target||'').trim().toUpperCase();
      if(!dk || !targetAtStart) return false;
      let res;
      try{
        res = await rpc('diaryGet', { callsign: targetAtStart, dateKey: dk }, { latestKey:'diary:admin:entry' });
      }catch(e){
        if(isStaleRequest_(e)) return false;
        throw e;
      }
      if(String(state.target||'').trim().toUpperCase() !== targetAtStart) return false;
      const out = res && (res.result || res);
      if(!out || !out.item){
        clearEditorForNew_(dk);
        setOk('New entry.');
        return true;
      }
      const it = out.item;
      try{ dateEl.value = normDateKey(it.dateKey||dk) || normDateKey(dk) || torontoDateKey(new Date()); }catch(_e){}
      try{ tagsEl.value = String(it.tags||''); }catch(_e2){}
      const htmlRaw = String((it.bodyRich!=null && it.bodyRich!==undefined) ? it.bodyRich : '').trim();
      const bodyRaw = String((it.body!=null && it.body!==undefined) ? it.body : '').trim();
      const html = htmlRaw ? toHtmlMaybe(htmlRaw) : toHtmlMaybe(bodyRaw);
      rich.setHtml(html||'');
      try{ updateWordCounter_(); }catch(_e3){}
      state.loadedDateKey = dk;
      state.loadedHadExisting = true;
      setOk('Loaded.');
      return true;
}

    async function save(){
      setErr(''); setOk('');
      const saveBtn = q('#slbDiarySave');
      let _slbSaveDelayT = null;
      if(saveBtn){
        saveBtn.disabled = true;
        // UX: don't scream "Saving..." instantly unless we're in debug mode.
        let pm = 'auto';
        try{ pm = String(sessionStorage.getItem('slb_progressMode') || localStorage.getItem('slb_progressMode') || 'auto').toLowerCase(); }catch(_e){}
        try{ if(pm==='auto'){
          const qs = String((location&&location.search)?location.search:'');
          if(qs){ const p = new URLSearchParams(qs); const dbg = p.get('slbdebug')||p.get('debug'); if(dbg==='1'||dbg==='true') pm='debug'; }
        }}catch(_e){}
        const delay = (pm === 'debug') ? 0 : 2000;
        if(delay <= 0){
          saveBtn.textContent = 'Saving...';
        }else{
          _slbSaveDelayT = setTimeout(()=>{ try{ if(saveBtn.disabled) saveBtn.textContent='Saving...'; }catch(_e){} }, delay);
        }
      }
      try{
        function withTimeout(promise, ms, label){
          ms = Number(ms||0);
          if(!(ms>0)) return promise;
          var to = null;
          return Promise.race([
            promise,
            new Promise(function(_, reject){
              to = setTimeout(function(){ reject(new Error((label||'Timeout') + ' (timeout)')); }, ms);
            })
          ]).finally(function(){
            try{ if(to) clearTimeout(to); }catch(_e){}
          });
        }
        if(!state.target){ setErr('Enter target callsign, then Load.'); return; }
        if(role.isModerator && !role.isAdmin){
          setErr('Moderator is read-only.');
          return;
        }
        const dk = String(dateEl.value||'').trim();
        if(!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dk)){
          setErr('Invalid date.');
          return;
        }
        let tags = String(tagsEl.value||'').trim();
        let bodyRich = rich.getHtml();
        let body = rich.getText();

        // Safety: if an entry already exists for this date, but we didn't load it, merge instead of overwrite.
        if(!state.loadedHadExisting){
          try{
            const res0 = await rpcWithTimeout('diaryGet', { callsign: state.target, dateKey: dk }, {}, 15000);
            const out0 = res0 && (res0.result || res0);
            if(out0 && out0.item){
              const ex = out0.item;
              const exHtmlRaw = String((ex.bodyRich!=null && ex.bodyRich!==undefined) ? ex.bodyRich : '').trim();
              const exBodyRaw = String((ex.body!=null && ex.body!==undefined) ? ex.body : '').trim();
              const exHtml = sanitizeRichHtml(exHtmlRaw ? toHtmlMaybe(exHtmlRaw) : toHtmlMaybe(exBodyRaw));
              const newHtml = sanitizeRichHtml(bodyRich);
              const mergedHtml = (exHtml && newHtml) ? (exHtml + '<br><br>' + newHtml) : (exHtml || newHtml);
              bodyRich = mergedHtml;
              body = htmlToPlain(mergedHtml);
              tags = mergeTags(String(ex.tags||''), tags);
            }
          }catch(_e){}
        }
        if(!body && !bodyRich){ setErr('Body is empty.'); return; }
        var _obDiary3 = { callsign: state.target, dateKey: dk, tags: tags, body: body, bodyRich: bodyRich };
        await rpcWithTimeout('diaryUpsert', _obDiary3, { outbox: { module: 'diary', key: obKeyDiary_(_obDiary3) } }, 30000);
        setOk('Saved.');
        // Post-save refresh is nice to have, but it must never leave the Save button stuck.
        try{ await withTimeout(loadList(true), 15000, 'Refresh list'); }catch(_e){}
        try{ await withTimeout(openEntry(dk), 15000, 'Reload entry'); }catch(_e){}
      }catch(e){
        setErr((e && (e.message||String(e))) || 'Save failed.');
      }finally{
        try{ if(_slbSaveDelayT) clearTimeout(_slbSaveDelayT); }catch(_e){}
        if(saveBtn){ saveBtn.disabled = false; saveBtn.textContent = 'Save'; }
      }
    }

    // bind inner
    q('#slbDiaryRefresh')?.addEventListener('click', ()=>loadList(true).catch(e=>setErr(e.message||String(e))));
    q('#slbDiaryMore')?.addEventListener('click', ()=>loadList(false).catch(e=>setErr(e.message||String(e))));
    q('#slbDiarySave')?.addEventListener('click', ()=>save().catch(e=>setErr(e.message||String(e))));

    if(dateEl){
      dateEl.addEventListener('change', ()=>{
        try{ saveDraftNow_(); }catch(_e){}
        const dk = String(dateEl.value||'').trim();
        ensureDateLoaded_(dk).catch(e=>setErr(e.message||String(e)));
      });
    }

    q('#slbDiaryList')?.addEventListener('click', (ev)=>{
      const b = ev.target.closest('button[data-open]');
      if(!b) return;
      const dk = String(b.getAttribute('data-open')||'').trim();
      openEntry(dk).catch(e=>setErr(e.message||String(e)));
    });

    const searchEl = q('#slbDiarySearch');
    if(searchEl){
      let t=null;
      searchEl.addEventListener('input', ()=>{
        clearTimeout(t);
        t = setTimeout(()=>loadList(true).catch(e=>setErr(e.message||String(e))), 300);
      });
    }

    // export
    q('#slbDiaryExportCsv')?.addEventListener('click', async ()=>{
      setErr(''); setOk('');
      if(!state.target){ setErr('Enter target callsign, then Load.'); return; }
      let part = 1;
      let before = '';
      while(true){
        const res = await rpc('diaryExportCsv', { callsign: state.target, partNumber: part, beforeDateKey: before, maxEntries: 200 });
        const out = res && (res.result || res);
        if(out && out.csvText) downloadText(out.fileName || ('Diary_part'+part+'.csv'), out.csvText);
        if(!(out && out.hasMore)) break;
        before = String(out.nextBeforeDateKey||'');
        part++;
        if(!confirm('More parts remain. Download next part?')) break;
      }
    });

    q('#slbDiaryExportZip')?.addEventListener('click', async ()=>{
      setErr(''); setOk('');
      if(!state.target){ setErr('Enter target callsign, then Load.'); return; }
      let part = 1;
      let before = '';
      while(true){
        const res = await rpc('diaryExportZip', { callsign: state.target, partNumber: part, beforeDateKey: before, maxEntries: 80 });
        const out = res && (res.result || res);
        if(out && out.zipBase64) downloadBase64(out.fileName || ('Diary_part'+part+'.zip'), out.zipBase64, 'application/zip');
        if(!(out && out.hasMore)) break;
        before = String(out.nextBeforeDateKey||'');
        part++;
        if(!confirm('More parts remain. Download next part?')) break;
      }
    });

    // load button
    $('slbDiaryAdmLoad')?.addEventListener('click', ()=>{
      const cs = String($('slbDiaryAdmCall')?.value||'').trim().toUpperCase();
      if(!cs){ setErr('Enter target callsign.'); return; }
      invalidateLatest_('diary:admin:entry');
      state.target = cs;
      state._autoInitDone = false;
      state.loadedHadExisting = false;
      try{ dateEl.value = torontoDateKey(new Date()); }catch(_e){}
      loadList(true).catch(e=>setErr(e.message||String(e)));
    });
  }

  // Public lifecycle API used by normal SLB navigation and My Cabin.
  window.SLB_DIARY = window.SLB_DIARY || {};
  window.SLB_DIARY.mount = function(){ return mountMain(); };
  window.SLB_DIARY.onOpen = function(){
    var ok = mountMain();
    if(ok){
      try{ var b=$('slbDiaryRefresh'); if(b && b.disabled!==true) b.click(); }catch(_e){}
    }
    return ok;
  };
  window.SLB_DIARY.reload = window.SLB_DIARY.onOpen;

  // Mount when the module loads, and retry once shared SLB auth is ready.
  function boot(){
    setTimeout(mountMain, 50);
    setTimeout(mountAdmin, 50);
  }
  try{ window.addEventListener('slb:auth-ready', function(){ setTimeout(mountMain, 0); }); }catch(_e){}

  boot();
})();

